var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ButtonComponent, { IS_COARSE_POINTER } from './ButtonComponent';
import customEventHandler from '../helper/customEvents';
import { v4 as uuidv4 } from 'uuid';
import ToggleButton from './ToggleButton';
import ToolTip from './ToolTip';
import '../styles/bottomPanel.scss';
import { t } from 'i18next';
import { useContext, useEffect, useReducer, useRef, useState } from 'react';
import { nmpAnimationTicker } from '../helper/nmpAnimationTicker';
import { announce } from '../helper/announcer';
import FlipButton from './FlipButton';
import CollapsibleDiv from './CollapsibleDiv';
import globalStore from '../store';
import { DataContext } from '../player/DataContext';
import InputBox from './InputBox';
import React from 'react';
import { SHAPE_PATHS, SHAPE_BOUNDS, UNIT as SHAPE_UNIT, } from '../widgets/patternShapesConstants';
import { computePatternShapeSnap } from '../widgets/patternShapesSnapHelper';
import { ColorEnum } from './ColorPicker';
import { saveState } from '../helper/stateManagerHelper';
import { calculateTokenPosition } from '../helper/tokenDropHelper';
import { calcScale as calcScaleHelper } from '../helper/scaleHelper';
import { getImageSrc } from '../helper/imageBlobCache';
import { NUMBER_COLORS, COIN_RENDER_DIMENSIONS, MONEY_GRIDS, PIECE_GRID as NMP_GRID_SIZE, NMP_PIECE_TYPE_CONFIG, PIECE_DIMENSIONS, MONEY_PIECE_DIMENSIONS, DENOM_BTN_MAP, isNmpAction, NMP_ANIMATING_ACTIONS, DRAG_CREATE_IDS, } from '../constants/nmpConstants';
import { playAudio } from '../helper/audioHelper';
import ChoralControlsDrawer from './ChoralControlsDrawer';
import StampEveryPopup from './StampEveryPopup';
import PopoverMenu from './PopoverMenu';
import FractionButton from './FractionButton';
import CustomScrollbar from './CustomScrollbar';
import BlocksComponent from './BlocksComponent';
import { isProperRectangle } from '../helper/helper';
import { createLinearPieceForSelectedTile as createLinearPieceForTile } from '../helper/linearPieceHelper';
import { GRID_SIZE } from '../constants/gridConstants';
import { solveNmpPieceSnap } from '../helper/snapHelper';
var BottomPanel = function (props) {
    var _a;
    var id = props.id, toolsBtn = props.toolsBtn, className = props.className, _b = props.disabledElements, disabledElements = _b === void 0 ? [] : _b, _c = props.collapsibleState, collapsibleState = _c === void 0 ? [] : _c, drawerOpen = props.drawerOpen, children = props.children, _d = props.disableTabFocus, disableTabFocus = _d === void 0 ? false : _d, tooltipDirection = props.tooltipDirection;
    var _e = useContext(DataContext), setText = _e.setText, selectedTool = _e.selectedTool, setSelectedTool = _e.setSelectedTool, text = _e.text, table = _e.table, setTable = _e.setTable, annotations = _e.annotations, manipulative = _e.manipulative, setManipulative = _e.setManipulative, selectedManipulativeId = _e.selectedManipulativeId, shades = _e.shades, setShades = _e.setShades, 
    // Choral Context
    setShowChoralDrawer = _e.setShowChoralDrawer, showChoralDrawer = _e.showChoralDrawer, 
    // Stamp Every Context
    setShowStampEveryPopup = _e.setShowStampEveryPopup, 
    // Manipulator popup
    setManiplulatorComponentVisible = _e.setManiplulatorComponentVisible;
    var _f = globalStore.useStoreState(function (st) { return st.playerStore; }), zoomLevel = _f.zoomLevel, isAdmin = _f.isAdmin, playerBgPattern = _f.playerBgPattern;
    var _g = useState(false), showLock = _g[0], setShowLock = _g[1];
    // Stores the content-lock state of the currently selected table cell.
    // Updated synchronously via 'tableCellLockState' event so the lock icon
    // reflects the correct state in the very first render after cell selection.
    var _h = useState(false), cellContentLocked = _h[0], setCellContentLocked = _h[1];
    var _j = useState(false), showLinkPopup = _j[0], setshowLinkPopup = _j[1];
    var _k = useState(false), showChoralDrawerSt = _k[0], setChoralDrawerSt = _k[1];
    var _l = useState(false), showStampEverySt = _l[0], setStampEverySt = _l[1];
    var _m = useState(false), showExchangePopupSt = _m[0], setExchangePopupSt = _m[1];
    var _o = useState(false), showChoralSettings = _o[0], setShowChoralSettings = _o[1];
    var _p = useState({}), hoveredShapeTools = _p[0], setHoveredShapeTools = _p[1];
    var _q = useState(false), selectModeActive = _q[0], setSelectModeActive = _q[1];
    var _r = useState({
        bold: false,
        italic: false,
        underline: false,
        leftAlign: false,
        centerAlign: false,
        rightAlign: false,
    }), formattingActive = _r[0], setFormattingActive = _r[1];
    var _s = useState(false), hasVerticalScroll = _s[0], setHasVerticalScroll = _s[1];
    var fractionGroupRef = useRef(null);
    // Reposition stampBtn's collapsible option panel after CollapsibleDiv
    // sets its inline left/top. The panel uses `position: fixed` (scoped CSS
    // override in collapsible.scss) to escape `.drawer-content`'s overflow,
    // but `.drawer-container` has a `transform` that makes it the containing
    // block — so the JS-computed coords land at drawer-container-relative
    // values, not viewport. Here we override left/top to put the panel right-
    // edge at the trigger button's left edge with vertical centering, all
    // expressed in drawer-container-relative space (left = trigger.left -
    // drawer.left - panelWidth - gap; same for top).
    useEffect(function () {
        var adjustStampPanel = function () {
            var panel = document.querySelector('.collapsibleOptionHolder.expanded_left.squareBox') ||
                document.querySelector('.collapsibleOptionHolder.expanding_left.squareBox');
            if (!panel)
                return;
            var collapsibleRight = panel.closest('.collapsibleRight');
            var trigger = collapsibleRight === null || collapsibleRight === void 0 ? void 0 : collapsibleRight.querySelector('button.collapsibleMainBtn');
            var drawer = panel.closest('.drawer-container');
            if (!trigger || !drawer)
                return;
            var tRect = trigger.getBoundingClientRect();
            var pRect = panel.getBoundingClientRect();
            var dRect = drawer.getBoundingClientRect();
            // Align the panel's right edge with the trigger button's right edge
            // (i.e. shifted right by the trigger button's width). Uses tRect.right
            // directly so it tracks any future button-size change automatically.
            var left = tRect.right - dRect.left - pRect.width;
            var top = tRect.top - dRect.top + (tRect.height - pRect.height) / 2;
            panel.style.left = "".concat(left, "px");
            panel.style.top = "".concat(top, "px");
        };
        // Watch the right side drawer for class/style changes that signal the
        // panel's open/close transitions (CollapsibleDiv flips
        // collapsed_left ↔ expanding_left ↔ expanded_left). Limiting to the
        // drawer keeps the observer cheap.
        var drawerEl = document.getElementById('rightSideDrawerContainer') || document.body;
        var obs = new MutationObserver(function () {
            requestAnimationFrame(adjustStampPanel);
        });
        obs.observe(drawerEl, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style'],
        });
        window.addEventListener('resize', adjustStampPanel);
        window.addEventListener('scroll', adjustStampPanel, true);
        requestAnimationFrame(adjustStampPanel);
        return function () {
            obs.disconnect();
            window.removeEventListener('resize', adjustStampPanel);
            window.removeEventListener('scroll', adjustStampPanel, true);
        };
    }, []);
    // Freeze manipulative snapshot during NMP animation so the right panel content doesn't
    // flicker on every 50-piece chunk insert. Snapshot captured at animation start, released
    // at animation end. Button disable logic re-evaluates only twice per animation.
    var _t = useReducer(function (x) { return x + 1; }, 0), forceNmpButtonUpdate = _t[1];
    var manipulativeLiveRef = useRef(manipulative);
    manipulativeLiveRef.current = manipulative; // always current — avoids stale closure in subscriber
    var frozenManipulativeRef = useRef(null);
    useEffect(function () { return nmpAnimationTicker.subscribe(function () {
        if (nmpAnimationTicker.isAnimating) {
            frozenManipulativeRef.current = manipulativeLiveRef.current; // snapshot current state
        }
        else {
            frozenManipulativeRef.current = null;
        }
        forceNmpButtonUpdate();
    }); }, []);
    var stableManipulative = (_a = frozenManipulativeRef.current) !== null && _a !== void 0 ? _a : manipulative;
    // Drag-from-panel ref for pattern shape buttons
    var patternDragRef = useRef(null);
    var lastPatternTouchRef = useRef(0);
    var handlePatternShapeMouseDown = function (e, shapeKey) {
        var _a;
        // Guard: skip synthetic mouse event fired by browser after a touch
        if ('touches' in e) {
            lastPatternTouchRef.current = Date.now();
        }
        else if (Date.now() - lastPatternTouchRef.current < 500) {
            return;
        }
        e.preventDefault();
        var clientX = 'clientX' in e ? e.clientX : e.touches[0].clientX;
        var clientY = 'clientY' in e ? e.clientY : e.touches[0].clientY;
        // Use the single source of truth for shape dimensions (from PatternShapesManipulative)
        var bounds = SHAPE_BOUNDS[shapeKey] || {
            x: 0,
            y: 0,
            w: SHAPE_UNIT,
            h: SHAPE_UNIT,
        };
        var z = zoomLevel || 1;
        var ghostW = bounds.w * z;
        var ghostH = bounds.h * z;
        var shapeColorMap = {
            triangle_equilateral: 'GREEN',
            triangle_right: 'PURPLE',
            square: 'ORANGE',
            rhombus_blue: 'BLUE',
            rhombus_white: 'WHITE',
            trapezoid: 'RED',
            hexagon: 'YELLOW',
        };
        var colorKey = (_a = shapeColorMap[shapeKey]) !== null && _a !== void 0 ? _a : 'BLUE';
        var fill = ColorEnum[colorKey] || '#ffffff';
        // Use canvas-sized paths (SHAPE_PATHS) so the ghost matches the dropped shape exactly
        var svgPath = SHAPE_PATHS[shapeKey];
        // Create floating ghost that follows the cursor
        // White rhombus ghost is rotated 45° to match its initial placement on stage
        var ghostRotation = shapeKey === 'rhombus_white' ? 45 : 0;
        var ghost = document.createElement('div');
        ghost.style.cssText = "\n      position:fixed; pointer-events:none; z-index:9999; opacity:0.85;\n      left:".concat(clientX - ghostW / 2, "px; top:").concat(clientY - ghostH / 2, "px;\n      width:").concat(ghostW, "px; height:").concat(ghostH, "px;\n      transform: rotate(").concat(ghostRotation, "deg); transform-origin: center;\n    ");
        // Use the exact same viewBox as the canvas shape (no padding needed — the stroke
        // is inside-clipped so it cannot extend beyond the fill path boundary).
        var strokeW = 2 / z;
        ghost.innerHTML = "<svg viewBox=\"".concat(bounds.x, " ").concat(bounds.y, " ").concat(bounds.w, " ").concat(bounds.h, "\" width=\"").concat(ghostW, "\" height=\"").concat(ghostH, "\" overflow=\"visible\">\n      <defs><clipPath id=\"ghostClip\"><path d=\"").concat(svgPath, "\"/></clipPath></defs>\n      <path d=\"").concat(svgPath, "\" fill=\"").concat(fill, "\" stroke=\"none\"/>\n      <path d=\"").concat(svgPath, "\" fill=\"none\" stroke=\"#001f5c\" stroke-width=\"").concat(strokeW * 2, "\" stroke-linejoin=\"miter\" clip-path=\"url(#ghostClip)\"/>\n    </svg>");
        document.body.appendChild(ghost);
        patternDragRef.current = { shapeKey: shapeKey, ghost: ghost, moved: false, startX: clientX, startY: clientY };
        var onMove = function (ev) {
            // Prevent iOS Safari from scrolling/bouncing the page during drag
            if ('touches' in ev)
                ev.preventDefault();
            var cx = 'clientX' in ev ? ev.clientX : ev.touches[0].clientX;
            var cy = 'clientX' in ev ? ev.clientY : ev.touches[0].clientY;
            if (patternDragRef.current) {
                if (Math.hypot(cx - patternDragRef.current.startX, cy - patternDragRef.current.startY) > 5) {
                    patternDragRef.current.moved = true;
                }
                if (patternDragRef.current.ghost) {
                    patternDragRef.current.ghost.style.left = "".concat(cx - ghostW / 2, "px");
                    patternDragRef.current.ghost.style.top = "".concat(cy - ghostH / 2, "px");
                }
            }
        };
        var onUp = function (ev) {
            var _a, _b, _c;
            var cx = 'clientX' in ev ? ev.clientX : ev.changedTouches[0].clientX;
            var cy = 'clientY' in ev ? ev.clientY : ev.changedTouches[0].clientY;
            // Remove ghost
            if ((_a = patternDragRef.current) === null || _a === void 0 ? void 0 : _a.ghost) {
                document.body.removeChild(patternDragRef.current.ghost);
            }
            if ((_b = patternDragRef.current) === null || _b === void 0 ? void 0 : _b.moved) {
                // Dropped — place shape at canvas coordinates
                var canvasEl = document.querySelector('.whiteboardScrollbar .customScrollbarContent');
                if (canvasEl) {
                    var rect = canvasEl.getBoundingClientRect();
                    if (cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom) {
                        var z_1 = zoomLevel || 1;
                        // Use actual shape bounds so the wrapper top-left is centered on the cursor
                        var dropType = shapeKey;
                        var dropBounds = SHAPE_BOUNDS[dropType] || {
                            x: 0,
                            y: 0,
                            w: SHAPE_UNIT,
                            h: SHAPE_UNIT,
                        };
                        var rawX = (canvasEl.scrollLeft + (cx - rect.left)) / z_1 - dropBounds.w / 2;
                        var rawY = (canvasEl.scrollTop + (cy - rect.top)) / z_1 - dropBounds.h / 2;
                        var dropInitialRotation = dropType === 'rhombus_white' ? 45 : 0;
                        var snapped = computePatternShapeSnap(rawX, rawY, dropType, dropInitialRotation, 1, [], manipulative, playerBgPattern !== null && playerBgPattern !== void 0 ? playerBgPattern : 'none');
                        var snappedX = snapped.x;
                        var snappedY = snapped.y;
                        var newId = "patternShapes_".concat(uuidv4().replace(/-/g, ''));
                        var color = (_c = shapeColorMap[shapeKey]) !== null && _c !== void 0 ? _c : 'BLUE';
                        // White rhombus starts tilted at 45° to match sidebar appearance and reference activity
                        var initialRotation = dropInitialRotation;
                        var newItem_1 = {
                            type: 'patternShapes',
                            data: {
                                id: newId,
                                type: 'patternShapes',
                                shapeType: shapeKey,
                                center: { x: snappedX, y: snappedY },
                                rotation: initialRotation,
                                scale: 1,
                                color: color,
                                lock: { positioning: false, editing: false },
                            },
                            widgetId: "patternShapes:".concat(uuidv4().replace(/-/g, '')),
                        };
                        saveState({
                            type: newId,
                            id: newId.split('_')[1],
                            propertyName: 'create',
                            old: JSON.stringify(newItem_1),
                        });
                        setManipulative(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newItem_1], false); });
                        playAudio('PatternAdd');
                        setSelectedTool([newId]);
                    }
                }
            }
            else {
                // Short tap/click — add to canvas centre (existing behaviour)
                customEventHandler.dispatchEvent('bottomPanel', { id: shapeKey, type: 'btn' });
            }
            patternDragRef.current = null;
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onUp);
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('touchend', onUp);
    };
    // Keyboard / click-without-drag path for the Vertical Pieces / Horizontal
    // Pieces buttons in the right tool panel. Delegates to the shared helper so
    // the right panel and the ColoredTiles context menu place single linear
    // pieces identically. Returns true if a piece was created, false if no tile
    // could be resolved (caller falls through to drag-only behaviour).
    var createLinearPieceForSelectedTile = function (toolId) { return createLinearPieceForTile(toolId, manipulative, selectedTool); };
    var handleLinearPieceMouseDown = function (e, toolId) {
        e.preventDefault();
        e.stopPropagation();
        var clientX = 'clientX' in e ? e.clientX : e.touches[0].clientX;
        var clientY = 'clientY' in e ? e.clientY : e.touches[0].clientY;
        var z = zoomLevel || 1;
        var cellSize = 110;
        var isHorizontal = toolId === 'horizontalPieces';
        var ghostW = isHorizontal ? (cellSize - 4) * z : 10 * z;
        var ghostH = isHorizontal ? 8 * z : (cellSize - 4) * z;
        var ghost = document.createElement('div');
        ghost.style.cssText = "\n    position:fixed; pointer-events:none; z-index:9999; opacity:0.85;\n    left:".concat(clientX - ghostW / 2, "px; top:").concat(clientY - ghostH / 2, "px;\n    width:").concat(ghostW, "px; height:").concat(ghostH, "px;\n    background: #FF0000;\n    border-radius: 1.375rem;\n    border: 1px solid #293273;\n  ");
        document.body.appendChild(ghost);
        var moved = false;
        var onMove = function (ev) {
            // Prevent scrolling on touch devices
            if ('touches' in ev)
                ev.preventDefault();
            var cx = 'clientX' in ev ? ev.clientX : ev.touches[0].clientX;
            var cy = 'clientY' in ev ? ev.clientY : ev.touches[0].clientY;
            moved = true;
            ghost.style.left = "".concat(cx - ghostW / 2, "px");
            ghost.style.top = "".concat(cy - ghostH / 2, "px");
        };
        var onUp = function (ev) {
            var cx = 'clientX' in ev ? ev.clientX : ev.changedTouches[0].clientX;
            var cy = 'clientY' in ev ? ev.clientY : ev.changedTouches[0].clientY;
            if (ghost.parentNode)
                ghost.parentNode.removeChild(ghost);
            if (moved) {
                var canvasEl = document.querySelector('.whiteboardScrollbar .customScrollbarContent');
                if (canvasEl) {
                    var rect = canvasEl.getBoundingClientRect();
                    if (cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom) {
                        var px = (canvasEl.scrollLeft + (cx - rect.left)) / z;
                        var py = (canvasEl.scrollTop + (cy - rect.top)) / z;
                        customEventHandler.dispatchEvent('bottomPanel', {
                            id: 'createLinearPiece',
                            data: {
                                type: isHorizontal ? 'horizontal' : 'vertical',
                                x: px,
                                y: py,
                            },
                        });
                    }
                }
            }
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onUp);
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('touchend', onUp);
    };
    // Drag-from-panel ref for drag-to-create buttons
    var dragToCreateRef = useRef(null);
    var DRAG_TO_CREATE_IDS = DRAG_CREATE_IDS;
    // Formatting buttons that should preserve the editor's text selection on click.
    // e.preventDefault() on mousedown stops the browser from blurring the
    // contenteditable (or table cell) and clearing the selection.
    var SELECTION_PRESERVING_IDS = new Set([
        'bold',
        'italic',
        'underline',
        'leftAlign',
        'centerAlign',
        'rightAlign',
        'larger',
        'smaller',
    ]);
    // Build drag ghost: try cloneNode first (pixel-perfect), fall back to programmatic
    var buildDragGhost = function (toolId) {
        var _a, _b;
        var denom = toolId.replace(/^nmp_/, '').replace(/_(colored|money)$/, '');
        var z = zoomLevel || 1;
        // Resolve group IDs to member pieces so drag ghost works for grouped NMP
        var resolvedIds = selectedTool.flatMap(function (sid) {
            return sid.startsWith('manipulativeGroup_')
                ? manipulative.filter(function (m) { return m.data.groupId === sid; }).map(function (m) { return m.data.id; })
                : [sid];
        });
        var selectedNmp = resolvedIds
            .map(function (sid) { return manipulative.find(function (m) { return m.data.id === sid; }); })
            .find(function (m) { return m && (m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'); });
        // Derive pieceType from dummy ID when no real piece is selected
        var CONFIG_KEY_TO_PIECE_TYPE = Object.fromEntries(Object.entries(NMP_PIECE_TYPE_CONFIG).map(function (_a) {
            var pieceType = _a[0], configKey = _a[1];
            return [configKey, pieceType];
        }));
        var dummyId = resolvedIds.find(function (id) { return id.endsWith('_dummyForRightTool'); });
        var dummyPieceType = dummyId
            ? CONFIG_KEY_TO_PIECE_TYPE[dummyId.replace('_dummyForRightTool', '')]
            : null;
        if (!selectedNmp && !dummyPieceType)
            return null;
        var pieceData = selectedNmp
            ? selectedNmp.data
            : {
                type: dummyPieceType === 'coins' || dummyPieceType === 'money' ? 'moneyPiece' : 'numberPiece',
                pieceType: dummyPieceType,
            };
        // Find existing scale from any piece of the same type+pieceType (all same-type pieces share scale)
        var existingPieceForScale = manipulative.find(function (m) {
            var d = m.data;
            return d.type === pieceData.type && d.pieceType === pieceData.pieceType;
        });
        var existingScale = (_b = (_a = existingPieceForScale === null || existingPieceForScale === void 0 ? void 0 : existingPieceForScale.data) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : 1;
        // sz: combines zoom and piece scale for correct ghost pixel dimensions in fallback path
        var sz = z * existingScale;
        // --- Try cloneNode: find piece matching target denomination + same pieceType ---
        var matchingPiece = manipulative.find(function (m) {
            var d = m.data;
            return (d.type === pieceData.type && d.pieceType === pieceData.pieceType && d.denomination === denom);
        });
        if (matchingPiece) {
            var sourceEl = document.querySelector("[data-nmp-id=\"".concat(matchingPiece.data.id, "\"]"));
            if (sourceEl) {
                var clone = sourceEl.cloneNode(true);
                clone.removeAttribute('data-nmp-id');
                var nmpCellSize = sourceEl.style.getPropertyValue('--nmpCellSize');
                // Element DOM size is already dims*pieceScale; apply zoomLevel to match on-screen appearance
                clone.style.cssText = "position:fixed;pointer-events:none;z-index:9999;transform:scale(".concat(z, ");transform-origin:top left;");
                if (nmpCellSize)
                    clone.style.setProperty('--nmpCellSize', nmpCellSize);
                return clone;
            }
        }
        // --- Programmatic fallback: build ghost from piece data ---
        var ghost = document.createElement('div');
        var border = '#293273';
        var internalBorder = '#000000';
        if (pieceData.type === 'numberPiece') {
            var typeColors = NUMBER_COLORS[pieceData.pieceType] || NUMBER_COLORS.numberYellow;
            var color = pieceData.color || typeColors[denom] || '#FFFF00';
            var CELL = NMP_GRID_SIZE * sz;
            if (denom === 'ones') {
                ghost.innerHTML = "<div style=\"width:".concat(CELL, "px;height:").concat(CELL, "px;background:").concat(color, ";outline:2px solid ").concat(border, ";outline-offset:0;border:none;\"></div>");
            }
            else if (denom === 'tens') {
                ghost.innerHTML = "<div style=\"width:".concat(CELL, "px;height:").concat(CELL * 10, "px;background:").concat(color, ";background-image:linear-gradient(").concat(internalBorder, " 1px,transparent 1px);background-size:").concat(CELL, "px ").concat(CELL, "px;outline:2px solid ").concat(border, ";outline-offset:0;border:none;\"></div>");
            }
            else {
                ghost.innerHTML = "<div style=\"width:".concat(CELL * 10, "px;height:").concat(CELL * 10, "px;background:").concat(color, ";background-image:linear-gradient(").concat(internalBorder, " 1px,transparent 1px),linear-gradient(90deg,").concat(internalBorder, " 1px,transparent 1px);background-size:").concat(CELL, "px ").concat(CELL, "px;outline:2px solid ").concat(border, ";outline-offset:0;border:none;\"></div>");
            }
        }
        else if (pieceData.type === 'moneyPiece') {
            var isCoin = pieceData.pieceType === 'coins';
            var imgPath = "./assets/images/manipulative/currency/".concat(denom, "Front.svg");
            if (isCoin) {
                var coinDim = COIN_RENDER_DIMENSIONS[denom];
                var s = coinDim ? { w: coinDim.width } : { w: 40 };
                var w = s.w * sz;
                var br = denom === 'dollar' ? '0' : '50%';
                var coinBorder = denom === 'dollar' ? "".concat(2 * sz, "px solid #5063AE") : "".concat(2 * sz, "px solid transparent");
                ghost.innerHTML = "<img src=\"".concat(imgPath, "\" style=\"width:").concat(w, "px;height:auto;border-radius:").concat(br, ";border:").concat(coinBorder, ";box-sizing:initial;object-fit:contain;\" draggable=\"false\"/>");
            }
            else {
                var g = MONEY_GRIDS[denom] || { cols: 1, rows: 1 };
                var CELL = NMP_GRID_SIZE * sz;
                var w = g.cols * CELL, h = g.rows * CELL;
                var OVERLAY_PCT = {
                    dollar: '75%',
                    halfDollar: '31%',
                    quarter: '24%',
                    dime: '89%',
                    nickel: '89%',
                    penny: '96%',
                };
                var ovPct = OVERLAY_PCT[denom] || '96%';
                var isDollar = denom === 'dollar';
                var gridBg = isDollar ? '#bfead6' : '#fff';
                var gridLineColor = isDollar ? '#61b995' : internalBorder;
                var imgOutline = isDollar ? 'outline:2px solid #01833e;' : '';
                ghost.innerHTML = "<div style=\"position:relative;width:".concat(w, "px;height:").concat(h, "px;background:").concat(gridBg, ";background-image:linear-gradient(").concat(gridLineColor, " 1px,transparent 1px),linear-gradient(90deg,").concat(gridLineColor, " 1px,transparent 1px);background-size:").concat(CELL, "px ").concat(CELL, "px;outline:2px solid ").concat(border, ";outline-offset:0;border:none;overflow:hidden;\"><img src=\"").concat(imgPath, "\" style=\"position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:").concat(ovPct, ";height:auto;object-fit:contain;").concat(imgOutline, "\" draggable=\"false\"/></div>");
            }
        }
        else {
            ghost.innerHTML = "<div style=\"width:40px;height:40px;background:#5063AE;border-radius:4px;border:2px solid #293273;\"></div>";
        }
        ghost.style.cssText = "position:fixed;pointer-events:none;z-index:9999;";
        return ghost;
    };
    // Creates an NMP piece at the given canvas-space coordinates. Used by both
    // drag-drop (drop position) and keyboard activation (canvas viewport
    // center) — keyboard activation needs this because the per-piece widget
    // listener that normally creates duplicates on a tool-button click only
    // fires when a real piece is selected.
    var createNmpPieceAt = function (toolId, canvasX, canvasY, avoidOverlap) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (avoidOverlap === void 0) { avoidOverlap = false; }
        var dummyForRightTool = selectedTool.every(function (t) { return t.endsWith('_dummyForRightTool'); });
        // Resolve pieceType: from dummy selection or from first real selected NMP piece
        var configKeyToPieceType = Object.fromEntries(Object.entries(NMP_PIECE_TYPE_CONFIG).map(function (_a) {
            var pt = _a[0], ck = _a[1];
            return [ck, pt];
        }));
        var pieceType = null;
        var selectedNmpColor;
        if (dummyForRightTool) {
            var dummyConfigKey = (_a = selectedTool[0]) === null || _a === void 0 ? void 0 : _a.replace('_dummyForRightTool', '');
            pieceType = (_b = (dummyConfigKey && configKeyToPieceType[dummyConfigKey])) !== null && _b !== void 0 ? _b : null;
        }
        else {
            // Expand group IDs to member piece IDs so we can find the first NMP piece
            var resolvedForCreate = selectedTool.flatMap(function (sid) {
                return sid.startsWith('manipulativeGroup_')
                    ? manipulative.filter(function (m) { return m.data.groupId === sid; }).map(function (m) { return m.data.id; })
                    : [sid];
            });
            var firstNmp = resolvedForCreate
                .map(function (sid) { return manipulative.find(function (m) { return m.data.id === sid; }); })
                .find(function (m) { return m && (m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'); });
            pieceType = firstNmp ? firstNmp.data.pieceType : null;
            selectedNmpColor = firstNmp ? firstNmp.data.color : undefined;
        }
        var denomination = DENOM_BTN_MAP[toolId];
        if (!pieceType || !denomination)
            return;
        var isNumber = pieceType === 'numberYellow' || pieceType === 'numberColored';
        var isCoin = pieceType === 'coins';
        var prefix = isNumber ? 'numberPiece' : 'moneyPiece';
        var newId = "".concat(prefix, "_").concat(uuidv4().replace(/-/g, ''));
        var dims = isNumber
            ? (_c = PIECE_DIMENSIONS[denomination]) !== null && _c !== void 0 ? _c : PIECE_DIMENSIONS.ones
            : isCoin
                ? (_d = COIN_RENDER_DIMENSIONS[denomination]) !== null && _d !== void 0 ? _d : PIECE_DIMENSIONS.ones
                : (_e = MONEY_PIECE_DIMENSIONS[denomination]) !== null && _e !== void 0 ? _e : PIECE_DIMENSIONS.ones;
        // Inherit scale from existing pieces of the same type so the new piece matches.
        // Prefer a piece from the selected group (if any) to match group scale.
        var selectedGroupId = selectedTool.length === 1 && selectedTool[0].startsWith('manipulativeGroup_')
            ? selectedTool[0]
            : null;
        var existingPiece = (selectedGroupId
            ? manipulative.find(function (m) { return m.data.groupId === selectedGroupId && m.data.type === prefix; })
            : manipulative.find(function (m) { return m.data.type === prefix; }));
        var existingScale = (_g = (_f = existingPiece === null || existingPiece === void 0 ? void 0 : existingPiece.data) === null || _f === void 0 ? void 0 : _f.scale) !== null && _g !== void 0 ? _g : 1;
        var existingColor = selectedNmpColor !== null && selectedNmpColor !== void 0 ? selectedNmpColor : (_h = existingPiece === null || existingPiece === void 0 ? void 0 : existingPiece.data) === null || _h === void 0 ? void 0 : _h.color;
        var w = dims.width * existingScale;
        var h = dims.height * existingScale;
        // Snap the drop position to nearest NMP piece (same logic as snapNMPPosition)
        var snapDropPosition = function (cx, cy) {
            if (isCoin)
                return { x: cx, y: cy };
            var topLeftX = cx - w / 2;
            var topLeftY = cy - h / 2;
            if (playerBgPattern === 'square') {
                var tlX = Math.round(topLeftX / NMP_GRID_SIZE) * NMP_GRID_SIZE;
                var tlY = Math.round(topLeftY / NMP_GRID_SIZE) * NMP_GRID_SIZE;
                return { x: tlX + w / 2, y: tlY + h / 2 };
            }
            // Same center-based classification the widget's own drop path uses.
            // Note the *rule* is shared, not the candidate projection: unlike
            // snapNMPPosition this list is same-`prefix` only, ignores rotation, and
            // sizes coin neighbours from MONEY_PIECE_DIMENSIONS. See NumberAndMoneyPiece.md.
            var others = manipulative.filter(function (m) { return m.data.type === prefix; });
            return solveNmpPieceSnap(cx, cy, w, h, others.map(function (other) {
                var _a, _b, _c;
                var od = other.data;
                var odScale = (_a = od.scale) !== null && _a !== void 0 ? _a : 1;
                var odDims = isNumber
                    ? (_b = PIECE_DIMENSIONS[od.denomination]) !== null && _b !== void 0 ? _b : PIECE_DIMENSIONS.ones
                    : (_c = MONEY_PIECE_DIMENSIONS[od.denomination]) !== null && _c !== void 0 ? _c : PIECE_DIMENSIONS.ones;
                var ow = odDims.width * odScale;
                var oh = odDims.height * odScale;
                return {
                    tlX: od.center.x - ow / 2,
                    tlY: od.center.y - oh / 2,
                    w: ow,
                    h: oh,
                    scale: odScale,
                };
            }), existingScale);
        };
        // Keyboard placement: if the requested center would overlap any existing
        // same-type NMP piece, scan outward in expanding rings until a clear spot
        // is found. The buffer is wider than the snap threshold so the subsequent
        // snapDropPosition won't pull the new piece back onto a neighbor.
        if (avoidOverlap) {
            var samePrefixOthers_1 = manipulative.filter(function (m) { return m.data.type === prefix; });
            // Tight buffer: a full cell, so the ring search lands the piece clear of
            // the (much smaller) adjacency allowance the subsequent snap step uses
            // and it isn't pulled back onto a neighbor. A wider buffer here is what
            // previously pushed tens too far apart horizontally.
            var BUFFER_1 = GRID_SIZE;
            var overlapsAt = function (cx, cy) {
                var _a, _b, _c, _d;
                var myL = cx - w / 2;
                var myR = cx + w / 2;
                var myT = cy - h / 2;
                var myB = cy + h / 2;
                for (var _i = 0, samePrefixOthers_2 = samePrefixOthers_1; _i < samePrefixOthers_2.length; _i++) {
                    var other = samePrefixOthers_2[_i];
                    var od = other.data;
                    var odScale = (_a = od.scale) !== null && _a !== void 0 ? _a : 1;
                    var odDims = isNumber
                        ? (_b = PIECE_DIMENSIONS[od.denomination]) !== null && _b !== void 0 ? _b : PIECE_DIMENSIONS.ones
                        : isCoin
                            ? (_c = COIN_RENDER_DIMENSIONS[od.denomination]) !== null && _c !== void 0 ? _c : PIECE_DIMENSIONS.ones
                            : (_d = MONEY_PIECE_DIMENSIONS[od.denomination]) !== null && _d !== void 0 ? _d : PIECE_DIMENSIONS.ones;
                    var ow = odDims.width * odScale;
                    var oh = odDims.height * odScale;
                    var oL = od.center.x - ow / 2 - BUFFER_1;
                    var oR = od.center.x + ow / 2 + BUFFER_1;
                    var oT = od.center.y - oh / 2 - BUFFER_1;
                    var oB = od.center.y + oh / 2 + BUFFER_1;
                    if (myL < oR && myR > oL && myT < oB && myB > oT)
                        return true;
                }
                return false;
            };
            if (samePrefixOthers_1.length > 0 && overlapsAt(canvasX, canvasY)) {
                // Per-axis step so non-square pieces (e.g. tens, 1×10) move just one
                // piece width over horizontally instead of spreading across the
                // canvas. Step = own dimension + buffer + 1 so the new piece clears
                // the inflated overlap zone on its first try and lands adjacent with
                // a one-cell gap.
                var stepX = w + BUFFER_1 + 1;
                var stepY = h + BUFFER_1 + 1;
                var placed = false;
                outer: for (var ring = 1; ring <= 40 && !placed; ring++) {
                    var rim = [];
                    for (var dy = -ring; dy <= ring; dy++)
                        rim.push({ dx: ring, dy: dy });
                    for (var dx = ring - 1; dx >= -ring; dx--)
                        rim.push({ dx: dx, dy: ring });
                    for (var dy = ring - 1; dy >= -ring; dy--)
                        rim.push({ dx: -ring, dy: dy });
                    for (var dx = -ring + 1; dx <= ring - 1; dx++)
                        rim.push({ dx: dx, dy: -ring });
                    for (var _i = 0, rim_1 = rim; _i < rim_1.length; _i++) {
                        var _m = rim_1[_i], dx = _m.dx, dy = _m.dy;
                        var tryX = canvasX + dx * stepX;
                        var tryY = canvasY + dy * stepY;
                        if (!overlapsAt(tryX, tryY)) {
                            canvasX = tryX;
                            canvasY = tryY;
                            placed = true;
                            break outer;
                        }
                    }
                }
            }
        }
        var snappedCenter = snapDropPosition(canvasX, canvasY);
        // Determine snappedId: find grid-aligned same-type pieces touching the drop position
        var newSnappedId;
        var touchingIds = [];
        if (!isCoin) {
            var myTLX_1 = snappedCenter.x - w / 2;
            var myTLY_1 = snappedCenter.y - h / 2;
            var gridStep_1 = NMP_GRID_SIZE * existingScale;
            var TOL_1 = 1;
            var touching = manipulative.filter(function (m) {
                var _a, _b, _c;
                if (m.data.type !== prefix)
                    return false;
                var od = m.data;
                var odScale = (_a = od.scale) !== null && _a !== void 0 ? _a : 1;
                var odDims = isNumber
                    ? (_b = PIECE_DIMENSIONS[od.denomination]) !== null && _b !== void 0 ? _b : PIECE_DIMENSIONS.ones
                    : (_c = MONEY_PIECE_DIMENSIONS[od.denomination]) !== null && _c !== void 0 ? _c : PIECE_DIMENSIONS.ones;
                var ow = odDims.width * odScale;
                var oh = odDims.height * odScale;
                var oTLX = od.center.x - ow / 2;
                var oTLY = od.center.y - oh / 2;
                var hOverlap = myTLX_1 < oTLX + ow + TOL_1 && myTLX_1 + w > oTLX - TOL_1;
                var vOverlap = myTLY_1 < oTLY + oh + TOL_1 && myTLY_1 + h > oTLY - TOL_1;
                if (!hOverlap || !vOverlap)
                    return false;
                // hOverlap/vOverlap alone allow a corner-only touch — two pieces
                // offset by exactly one full cell on BOTH axes are simultaneously
                // "flush" on x and "flush" on y, sharing only a single diagonal
                // point with zero real area overlap. Require genuine (non-boundary)
                // overlap on at least one axis, mirroring the same fix in
                // NumberAndMoneyPieceManipulative.tsx and solveNmpPieceSnap.
                var hRealOverlap = myTLX_1 < oTLX + ow - TOL_1 && myTLX_1 + w > oTLX + TOL_1;
                var vRealOverlap = myTLY_1 < oTLY + oh - TOL_1 && myTLY_1 + h > oTLY + TOL_1;
                if (!hRealOverlap && !vRealOverlap)
                    return false;
                var dx = myTLX_1 - oTLX;
                var dy = myTLY_1 - oTLY;
                var xAligned = Math.abs(Math.round(dx / gridStep_1) * gridStep_1 - dx) < TOL_1;
                var yAligned = Math.abs(Math.round(dy / gridStep_1) * gridStep_1 - dy) < TOL_1;
                return xAligned && yAligned;
            });
            if (touching.length > 0) {
                newSnappedId =
                    (_l = (_k = (_j = touching.find(function (m) { return m.data.snappedId; })) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.snappedId) !== null && _l !== void 0 ? _l : uuidv4().replace(/-/g, '');
                touchingIds = touching.map(function (m) { return m.data.id; });
            }
        }
        var nmpItemsForZ = manipulative.filter(function (m) { return m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'; });
        var maxZForNew = nmpItemsForZ.reduce(function (max, m) { var _a; return Math.max(max, (_a = m.data.zIndex) !== null && _a !== void 0 ? _a : 1); }, 0);
        var pieceData = __assign(__assign({ id: newId, type: prefix, pieceType: pieceType, denomination: denomination, animation: true, center: snappedCenter, dimensions: __assign({}, dims), defaultDimensions: __assign({}, dims), scale: existingScale, rotation: 0, zIndex: maxZForNew + 1, lock: { positioning: false, editing: false } }, (existingColor && { color: existingColor })), (newSnappedId && { snappedId: newSnappedId }));
        if (!isNumber)
            pieceData.isFlipped = false;
        var newItem = {
            type: prefix,
            widgetId: "".concat(prefix, ":").concat(uuidv4().replace(/-/g, '')),
            data: pieceData,
        };
        saveState({
            type: newId,
            id: newId.split('_')[1],
            propertyName: 'batchCreate',
            old: JSON.stringify([newItem]),
        });
        setManipulative(function (prev) { return __spreadArray(__spreadArray([], prev.map(function (item) {
            return newSnappedId &&
                touchingIds.includes(item.data.id) &&
                !item.data.snappedId
                ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { snappedId: newSnappedId }) }) : item;
        }), true), [
            newItem,
        ], false); });
    };
    var handleDragToCreate = function (e, toolId) {
        e.preventDefault();
        var clientX = 'clientX' in e ? e.clientX : e.touches[0].clientX;
        var clientY = 'clientY' in e ? e.clientY : e.touches[0].clientY;
        var ghost = buildDragGhost(toolId);
        if (!ghost)
            return;
        // Don't append ghost yet — only show once drag threshold is crossed
        var ghostW = 0;
        var ghostH = 0;
        dragToCreateRef.current = { toolId: toolId, ghost: ghost, moved: false, startX: clientX, startY: clientY };
        var getCanvasEl = function () {
            return document.querySelector('.whiteboardScrollbar .customScrollbarContent');
        };
        var clampToCanvas = function (rawCx, rawCy, gW, gH) {
            if (gW === void 0) { gW = 0; }
            if (gH === void 0) { gH = 0; }
            var canvasEl = getCanvasEl();
            if (!canvasEl)
                return { cx: rawCx, cy: rawCy };
            var rect = canvasEl.getBoundingClientRect();
            return {
                cx: Math.max(rect.left + gW / 2, Math.min(rawCx, rect.right - gW / 2)),
                cy: Math.max(rect.top + gH / 2, Math.min(rawCy, rect.bottom - gH / 2)),
            };
        };
        var onMove = function (ev) {
            if ('touches' in ev)
                ev.preventDefault();
            var rawCx = 'clientX' in ev ? ev.clientX : ev.touches[0].clientX;
            var rawCy = 'clientY' in ev ? ev.clientY : ev.touches[0].clientY;
            if (dragToCreateRef.current) {
                if (!dragToCreateRef.current.moved &&
                    Math.hypot(rawCx - dragToCreateRef.current.startX, rawCy - dragToCreateRef.current.startY) > 5) {
                    dragToCreateRef.current.moved = true;
                    // Append ghost only when drag actually starts
                    document.body.appendChild(ghost);
                    var ghostRect = ghost.getBoundingClientRect();
                    ghostW = ghostRect.width;
                    ghostH = ghostRect.height;
                }
                if (dragToCreateRef.current.moved && dragToCreateRef.current.ghost) {
                    var _a = clampToCanvas(rawCx, rawCy, ghostW, ghostH), cx = _a.cx, cy = _a.cy;
                    dragToCreateRef.current.ghost.style.left = "".concat(cx - ghostW / 2, "px");
                    dragToCreateRef.current.ghost.style.top = "".concat(cy - ghostH / 2, "px");
                }
            }
        };
        var onUp = function (ev) {
            var _a, _b, _c, _d;
            var rawCx = 'clientX' in ev ? ev.clientX : ev.changedTouches[0].clientX;
            var rawCy = 'clientY' in ev ? ev.clientY : ev.changedTouches[0].clientY;
            if (((_a = dragToCreateRef.current) === null || _a === void 0 ? void 0 : _a.moved) && ((_b = dragToCreateRef.current) === null || _b === void 0 ? void 0 : _b.ghost)) {
                document.body.removeChild(dragToCreateRef.current.ghost);
            }
            if ((_c = dragToCreateRef.current) === null || _c === void 0 ? void 0 : _c.moved) {
                var canvasEl = getCanvasEl();
                if (canvasEl) {
                    var _e = clampToCanvas(rawCx, rawCy), cx = _e.cx, cy = _e.cy;
                    var z = zoomLevel || 1;
                    // Use mainHolder (the CSS-scaled canvas element) for coordinate conversion.
                    // The scroll container (customScrollbarContent) has margin: auto on its
                    // wrapperDiv child, so its rect.left != the canvas's visual left edge at
                    // zoom < 100%. mainHolder.getBoundingClientRect() already factors in both
                    // the centering margin and the scroll offset.
                    var mainBoard = document.querySelector('.mainHolder');
                    var originRect = mainBoard ? mainBoard.getBoundingClientRect() : canvasEl.getBoundingClientRect();
                    var canvasX = (cx - originRect.left) / z;
                    var canvasY = (cy - originRect.top) / z;
                    var toolId_1 = dragToCreateRef.current.toolId;
                    if (toolId_1.startsWith('nmp_')) {
                        createNmpPieceAt(toolId_1, canvasX, canvasY);
                    }
                    else {
                        customEventHandler.dispatchEvent('bottomPanel', {
                            panel: 'bottomPanel',
                            id: toolId_1,
                            type: 'btn',
                            center: { x: canvasX, y: canvasY },
                        });
                    }
                }
                // Blur the button so a subsequent Space press doesn't re-trigger it
                (_d = document.activeElement) === null || _d === void 0 ? void 0 : _d.blur();
            }
            // Non-drag clicks are handled by clickHandler — just clean up here
            dragToCreateRef.current = null;
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onUp);
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('touchend', onUp);
    };
    // Guard ref to prevent StrictMode double-fire for toggle button events
    var toggleGuardRef = useRef({});
    // Cleanup effect to reset all popups on unmount
    useEffect(function () {
        return function () {
            setShowLock(false);
            setshowLinkPopup(false);
            setChoralDrawerSt(false);
            setStampEverySt(false);
            setExchangePopupSt(false);
            setShowChoralSettings(false);
        };
    }, []);
    // Sync lock state when selection or table data changes.
    // When no table cell is selected: reset showLock and cellContentLocked.
    // When a table cell IS selected: sync cellContentLocked from table data so it's
    // always up-to-date — covers lock toggles, re-selection after click-outside, and
    // any table state change that affects the editing lock.
    useEffect(function () {
        if (!selectedTool.some(function (t) { return t.startsWith('tableText_'); })) {
            setShowLock(false);
            setCellContentLocked(false);
        }
        else if (!selectModeActive) {
            var lockArr = contentLockArray();
            setCellContentLocked(lockArr[1]);
        }
    }, [selectedTool, table, selectModeActive]);
    // Listen for cell content-lock state changes dispatched by TableManipulativeComp.
    // The event fires synchronously inside the React mousedown handler so the state
    // update is batched with setSelectedTool — both resolve in one render, no lag.
    useEffect(function () {
        var handler = function (d) { return setCellContentLocked(d.locked); };
        customEventHandler.addEventListener('tableCellLockState', handler);
        return function () { return customEventHandler.removeEventListener('tableCellLockState', handler); };
    }, []);
    // Listen for select mode changes from TableManipulativeComp
    useEffect(function () {
        var handleSelectMode = function (data) {
            setSelectModeActive(data.active);
        };
        customEventHandler.addEventListener('selectModeChanged', handleSelectMode);
        return function () {
            customEventHandler.removeEventListener('selectModeChanged', handleSelectMode);
        };
    }, []);
    // The text context menu's "Add Link" button dispatches `openLinkPopup` to
    // surface this BottomPanel's inline URL input.
    useEffect(function () {
        var handler = function () { return setshowLinkPopup(true); };
        customEventHandler.addEventListener('openLinkPopup', handler);
        return function () { return customEventHandler.removeEventListener('openLinkPopup', handler); };
    }, []);
    // Listen for formatting state changes (bold/italic/underline) from MathEditor
    var prevFormattingRef = useRef(formattingActive);
    useEffect(function () {
        var handleFormattingState = function (data) {
            var prev = prevFormattingRef.current;
            // Announce what changed
            var announcements = {
                bold: { on: 'text.boldOn', off: 'text.boldOff' },
                italic: { on: 'text.italicOn', off: 'text.italicOff' },
                underline: { on: 'text.underlineOn', off: 'text.underlineOff' },
                leftAlign: { on: 'text.alignedLeft', off: '' },
                centerAlign: { on: 'text.alignedCenter', off: '' },
                rightAlign: { on: 'text.alignedRight', off: '' },
            };
            for (var _i = 0, _a = Object.keys(announcements); _i < _a.length; _i++) {
                var key = _a[_i];
                if (data[key] !== prev[key] && data[key] !== undefined) {
                    var msg = data[key] ? announcements[key].on : announcements[key].off;
                    if (msg)
                        announce(t(msg));
                }
            }
            prevFormattingRef.current = data;
            setFormattingActive(data);
        };
        customEventHandler.addEventListener('formattingStateChanged', handleFormattingState);
        return function () {
            customEventHandler.removeEventListener('formattingStateChanged', handleFormattingState);
        };
    }, []);
    useEffect(function () {
        if (!(selectedManipulativeId === null || selectedManipulativeId === void 0 ? void 0 : selectedManipulativeId.startsWith('fractionTiles_'))) {
            setHasVerticalScroll(false);
            return;
        }
        var groupContainer = fractionGroupRef.current;
        if (!groupContainer)
            return;
        var scrollContainer = groupContainer.parentElement;
        if (!scrollContainer)
            return;
        var checkScrollbar = function () {
            var hasScroll = scrollContainer.scrollHeight > scrollContainer.clientHeight;
            setHasVerticalScroll(hasScroll);
        };
        checkScrollbar();
        var observer = new ResizeObserver(checkScrollbar);
        observer.observe(scrollContainer);
        return function () { return observer.disconnect(); };
    }, [selectedManipulativeId]);
    // --- CONFIG FOR RIGHT SIDE PANEL ---
    var isRightPanel = id === 'rightSideToolPanel';
    var commonDirection = isRightPanel ? 'left' : (tooltipDirection !== null && tooltipDirection !== void 0 ? tooltipDirection : 'bottom');
    var collapsibleDirection = isRightPanel ? 'left' : 'bottom';
    var commonIsRelative = isRightPanel ? true : false;
    var commonToolTipCSS = '';
    // Set to FALSE to allow the Sidebar-style Font Scaling in tooltips
    var useWhiteBoardMode = false;
    // --- HELPER: CLOSE ALL POPUPS ---
    var closeAllPopups = function () {
        setShowChoralDrawer(false);
        setShowChoralSettings(false);
        setChoralDrawerSt(false);
        setShowStampEveryPopup(false);
        setStampEverySt(false);
        setExchangePopupSt(false);
        setshowLinkPopup(false);
        setShowLock(false);
    };
    // --- HELPER: CLOSE MANIPULATOR POPUP (for right panel) ---
    var closeManipulatorPopup = function () {
        if (isRightPanel) {
            setManiplulatorComponentVisible(false);
        }
    };
    var toggleLockState = function (index) {
        var lockArray = contentLockArray();
        var key = index === 0 ? 'positioning' : 'editing';
        console.log('[BP] toggleLockState index=', index, 'key=', key, 'lockArray=', lockArray);
        var newState = !lockArray[index];
        selectedTool.forEach(function (toolId) {
            if (toolId.startsWith('text_')) {
                var textIndex_1 = Number(toolId.split('_')[1]);
                setText(function (prev) {
                    var updated = __spreadArray([], prev, true);
                    var item = updated[textIndex_1];
                    if (!item.data.lock) {
                        item.data.lock = { positioning: false, editing: false };
                    }
                    item.data.lock[key] = newState;
                    return updated;
                });
            }
            else if (toolId.startsWith('tableText_')) {
                var _a = toolId.split('_'), tableIndexStr = _a[1];
                var tableIndex_1 = Number(tableIndexStr);
                if (key === 'positioning') {
                    // Position lock is table-level
                    setTable(function (prev) {
                        var updatedTable = __spreadArray([], prev, true);
                        var tableItem = __assign({}, updatedTable[tableIndex_1]);
                        var tableData = __assign({}, tableItem.data);
                        if (!tableData.lock) {
                            tableData.lock = { positioning: false, editing: false };
                        }
                        tableData.lock.positioning = newState;
                        tableItem.data = tableData;
                        updatedTable[tableIndex_1] = tableItem;
                        return updatedTable;
                    });
                }
                else if (key === 'editing') {
                    // Content lock is per-cell: dispatch event so TableManipulativeComp applies it
                    customEventHandler.dispatchEvent('tableContentLockToggle', {
                        tableIndex: tableIndex_1,
                        newState: newState,
                    });
                }
            }
            else if (toolId.startsWith('numberFrame_')) {
                if (key === 'positioning') {
                    // Position lock: lock frame + all attached counters (positioning only)
                    setManipulative(function (prev) {
                        // Find the frame to compute snapped positions for counters
                        var frameItem = prev.find(function (m) { return m.data.id === toolId; });
                        var frameData = frameItem === null || frameItem === void 0 ? void 0 : frameItem.data;
                        return prev.map(function (item) {
                            if (item.data.id === toolId) {
                                return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { lock: __assign(__assign({}, item.data.lock), { positioning: newState }) }) });
                            }
                            if (item.data.type === 'numberFrameCounter' && item.data.frameId === toolId) {
                                var center = item.data.center;
                                // Snap counter center to its calculated frame position before locking
                                // so actualPosition (which falls back to center when locked) doesn't shift
                                if (newState && (frameData === null || frameData === void 0 ? void 0 : frameData.tokens)) {
                                    var cellIndex = -1;
                                    for (var _i = 0, _a = Object.entries(frameData.tokens); _i < _a.length; _i++) {
                                        var _b = _a[_i], ci = _b[0], tokenId = _b[1];
                                        if (tokenId === item.data.id) {
                                            cellIndex = parseInt(ci);
                                            break;
                                        }
                                    }
                                    if (cellIndex !== -1) {
                                        center = calculateTokenPosition(frameData, cellIndex);
                                    }
                                }
                                return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { center: center, lock: __assign(__assign({}, item.data.lock), { positioning: newState }) }) });
                            }
                            return item;
                        });
                    });
                }
                else if (key === 'editing') {
                    // Content lock: lock frame editing + all counters in their cells
                    setManipulative(function (prev) {
                        return prev.map(function (item) {
                            if (item.data.id === toolId) {
                                return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { lock: __assign(__assign({}, item.data.lock), { editing: newState }) }) });
                            }
                            if (item.data.type === 'numberFrameCounter' && item.data.frameId === toolId) {
                                return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { lock: __assign(__assign({}, item.data.lock), { editing: newState }) }) });
                            }
                            return item;
                        });
                    });
                }
            }
            else if (toolId.startsWith('dice_') ||
                toolId.startsWith('deck_') ||
                toolId.startsWith('spinner') ||
                toolId.startsWith('analog') ||
                toolId.startsWith('timer') ||
                toolId.startsWith('numberChart') ||
                toolId.startsWith('numberRacks') ||
                toolId.startsWith('protractor') ||
                toolId.startsWith('timer') ||
                toolId.startsWith('patternShapes_') ||
                toolId.startsWith('numberPiece_') ||
                toolId.startsWith('moneyPiece_') ||
                toolId.startsWith('coloredTiles') ||
                toolId.startsWith('linearPiece_') ||
                toolId.startsWith('coinsAndCounters_')) {
                var _oldDataLock_1;
                var _newDataLock_1;
                var _newLockState_1 = manipulative.map(function (item) {
                    var _a;
                    if (item.data.id === toolId) {
                        _oldDataLock_1 = item;
                        _newDataLock_1 = __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { lock: __assign(__assign({}, item.data.lock), (_a = {}, _a[key] = newState, _a)) }) });
                        return _newDataLock_1;
                    }
                    else {
                        return item;
                    }
                });
                console.log(_oldDataLock_1, _newDataLock_1, '@@@@@ history');
                if (_oldDataLock_1 && _newDataLock_1) {
                    saveState({
                        type: toolId,
                        id: toolId.split('_')[1],
                        propertyName: 'completeData',
                        old: JSON.stringify(_oldDataLock_1.data),
                        new: JSON.stringify(_newDataLock_1.data),
                    });
                }
                setManipulative(function () { return _newLockState_1; });
                // setManipulative(prev => {
                //   const updated = [...prev];
                //   const item = updated.find(item => item.data.id === toolId);
                //   if (!item) return prev;
                //   item.data.lock[key] = newState;
                //   return updated;
                // });
            }
            else if (toolId.startsWith('manipulativeGroup_')) {
                setManipulative(function (prev) {
                    return prev.map(function (item) {
                        var _a;
                        if (item.data.groupId === toolId) {
                            return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { lock: __assign(__assign({}, item.data.lock), (_a = {}, _a[key] = newState, _a)) }) });
                        }
                        return item;
                    });
                });
            }
            else if (toolId.startsWith('shades_')) {
                var splitId = toolId.split('_');
                var shadeIndex_1 = Number(splitId[splitId.length - 1]);
                setShades(function (prev) {
                    var _a;
                    var updated = __spreadArray([], prev, true);
                    if (updated[shadeIndex_1]) {
                        var oldData = __assign({}, updated[shadeIndex_1]);
                        updated[shadeIndex_1] = __assign(__assign({}, updated[shadeIndex_1]), { data: __assign(__assign({}, updated[shadeIndex_1].data), { lock: __assign(__assign({}, updated[shadeIndex_1].data.lock), (_a = {}, _a[key] = newState, _a)) }) });
                        saveState({
                            type: 'shades',
                            id: String(shadeIndex_1),
                            propertyName: 'completeData',
                            old: JSON.stringify(oldData),
                            new: JSON.stringify(updated[shadeIndex_1]),
                        });
                    }
                    return updated;
                });
            }
        });
    };
    var calcScale = function () { return calcScaleHelper(selectedTool, manipulative, table); };
    var contentLockArray = function () {
        var sizingOR = false;
        var editingOR = false;
        selectedTool.forEach(function (toolId) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            var lock = { positioning: false, editing: false };
            if (toolId.startsWith('text_')) {
                var index = Number(toolId.split('_')[1]);
                var item = text[index];
                if (item) {
                    lock.positioning = ((_a = item.data.lock) === null || _a === void 0 ? void 0 : _a.positioning) || false;
                    lock.editing = ((_b = item.data.lock) === null || _b === void 0 ? void 0 : _b.editing) || false;
                }
            }
            if (toolId.startsWith('tableText_')) {
                var parts = toolId.split('_');
                var tableIndex = Number(parts[1]);
                var tableItem = table[tableIndex];
                if (!tableItem)
                    return;
                // Position lock is table-level
                lock.positioning = ((_c = tableItem.data.lock) === null || _c === void 0 ? void 0 : _c.positioning) || false;
                // Editing lock is cell-level or all-cells for table-level selection
                if (parts.length >= 4) {
                    var rowIndex = Number(parts[2]);
                    var colIndex = Number(parts[3]);
                    var cols = tableItem.data.colWidth.length;
                    var cellIndex = rowIndex * cols + colIndex;
                    var cell = tableItem.data.cellData[cellIndex];
                    if (cell) {
                        lock.editing = ((_d = cell.data.lock) === null || _d === void 0 ? void 0 : _d.editing) || false;
                    }
                }
                else {
                    // Table-level selection: show locked if all cells are locked
                    lock.editing =
                        ((_e = tableItem.data.cellData) === null || _e === void 0 ? void 0 : _e.length) > 0 &&
                            tableItem.data.cellData.every(function (c) { var _a, _b; return ((_b = (_a = c === null || c === void 0 ? void 0 : c.data) === null || _a === void 0 ? void 0 : _a.lock) === null || _b === void 0 ? void 0 : _b.editing) === true; });
                }
            }
            if (toolId.startsWith('annotations_')) {
                var index = Number(toolId.split('_')[1]);
                var item = annotations[index];
                if (item) {
                    lock.positioning = ((_f = item.data.lock) === null || _f === void 0 ? void 0 : _f.positioning) || false;
                    lock.editing = ((_g = item.data.lock) === null || _g === void 0 ? void 0 : _g.editing) || false;
                }
            }
            if (toolId.startsWith('shades_')) {
                var shadeSplit = toolId.split('_');
                var index = Number(shadeSplit[shadeSplit.length - 1]);
                var item = shades[index];
                if (item) {
                    lock.positioning = ((_h = item.data.lock) === null || _h === void 0 ? void 0 : _h.positioning) || false;
                    lock.editing = ((_j = item.data.lock) === null || _j === void 0 ? void 0 : _j.editing) || false;
                }
            }
            if (toolId.startsWith('dice_') ||
                toolId.startsWith('deck_') ||
                toolId.startsWith('spinner') ||
                toolId.startsWith('analog') ||
                toolId.startsWith('numberChart') ||
                toolId.startsWith('timer') ||
                toolId.startsWith('numberRacks') ||
                toolId.startsWith('protractor') ||
                toolId.startsWith('arrayModel') ||
                toolId.startsWith('patternShapes_') ||
                toolId.startsWith('numberPiece_') ||
                toolId.startsWith('moneyPiece_') ||
                toolId.startsWith('linearPiece_') ||
                toolId.startsWith('coinsAndCounters_')) {
                var items = manipulative.find(function (item) { return item.data.id === toolId; });
                if (items) {
                    lock.positioning = ((_k = items.data.lock) === null || _k === void 0 ? void 0 : _k.positioning) || false;
                    lock.editing = ((_l = items.data.lock) === null || _l === void 0 ? void 0 : _l.editing) || false;
                }
            }
            if (toolId.startsWith('counter_') || toolId.startsWith('numberFrameCounter_')) {
                var counterItem = manipulative.find(function (item) { return item.data.id === toolId; });
                if (counterItem) {
                    lock.positioning = ((_m = counterItem.data.lock) === null || _m === void 0 ? void 0 : _m.positioning) || false;
                    lock.editing = ((_o = counterItem.data.lock) === null || _o === void 0 ? void 0 : _o.editing) || false;
                }
            }
            if (toolId.startsWith('numberFrame_')) {
                var frameItem = manipulative.find(function (item) { return item.data.id === toolId; });
                if (frameItem) {
                    lock.positioning = ((_p = frameItem.data.lock) === null || _p === void 0 ? void 0 : _p.positioning) || false;
                    lock.editing = ((_q = frameItem.data.lock) === null || _q === void 0 ? void 0 : _q.editing) || false;
                }
            }
            if (toolId.startsWith('manipulativeGroup_')) {
                var items = manipulative.find(function (item) { return item.data.groupId === toolId; });
                if (items) {
                    lock.positioning = ((_r = items.data.lock) === null || _r === void 0 ? void 0 : _r.positioning) || false;
                    lock.editing = ((_s = items.data.lock) === null || _s === void 0 ? void 0 : _s.editing) || false;
                }
            }
            sizingOR = sizingOR || lock.positioning;
            editingOR = editingOR || lock.editing;
        });
        return [sizingOR, editingOR];
    };
    var linkInput = function (id, event, val) {
        if (event === 'blur' || event === 'keyUp') {
            customEventHandler.dispatchEvent('bottomPanel', {
                panel: 'bottomPanel',
                id: id,
                val: val,
            });
            setTimeout(function () {
                setshowLinkPopup(true);
            }, 100);
        }
    };
    var flipBtnBool = function () {
        if (selectedTool.length === 0)
            return false;
        var _bool = false;
        selectedTool.forEach(function (tool) {
            if (tool.startsWith('annotations')) {
                var pos = Number(tool.split('_')[1]);
                var ann = annotations[pos];
                if (!ann)
                    return;
                if (ann.data.active) {
                    _bool = _bool || ann.data.active;
                }
                else {
                    _bool = _bool || ann.data.style === 'outline';
                }
            }
        });
        return _bool;
    };
    var btnDisable = function (_id) {
        var _a;
        // Disable "Create Outline" when no real (non-dummy) patternShapes shape is selected.
        // A shape becomes a _dummyForRightTool after being converted to an outline — it is no
        // longer a real selectable shape, so it must not count as a valid selection here.
        if (_id === 'outline' && id === 'rightSideToolPanel') {
            var hasRealShapeSelected = selectedTool.some(function (sid) {
                if (sid.startsWith('patternShapes_') && !sid.endsWith('_dummyForRightTool'))
                    return true;
                if (sid.startsWith('manipulativeGroup_')) {
                    return manipulative.some(function (m) {
                        var _a;
                        return m.data.groupId === sid &&
                            ((_a = m.data.id) === null || _a === void 0 ? void 0 : _a.startsWith('patternShapes_')) &&
                            !m.data.isOutline &&
                            !m.data.isStaticOutline &&
                            m.data.shapeType !== 'outline';
                    });
                }
                return false;
            });
            return !hasRealShapeSelected;
        }
        // NMP action buttons that operate on a selection must be disabled when
        // nothing is selected — otherwise they appear visually inactive but stay
        // Tab-focusable and dispatch no-op clicks. Applies to every panel the
        // buttons can appear in (rightSideToolPanel, toolBottomPanel, etc.) so
        // the `selectedTool.length === 0` short-circuit below doesn't mark them
        // enabled. We use isNmpAction() so all variant suffixes (_colored,
        // _money, _yellow) match a single base id.
        var SELECTION_REQUIRED_BASE_ACTIONS = [
            'nmp_exchange',
            'nmp_flip',
            'nmp_rotate',
            'nmp_break',
            'nmp_link',
        ];
        if (selectedTool.length === 0 &&
            SELECTION_REQUIRED_BASE_ACTIONS.some(function (a) { return isNmpAction(_id, a); })) {
            return true;
        }
        // Disable colored-tile operating buttons when nothing is selected (panel just
        // opened from the side bar with no tile on canvas yet).
        if (selectedTool.length === 0 && id === 'rightSideToolPanel') {
            var tileOperatingButtons = [
                'addRow', 'addColumn', 'removeRow', 'removeColumn',
                'addAllVertical', 'addAllHorizontal',
                'toggleExpression', 'toggleProduct', 'dimensionLabels',
                'partMode', 'selectMode', 'groupVertical', 'groupHorizontal',
            ];
            if (tileOperatingButtons.includes(_id))
                return true;
        }
        if (selectedTool.length === 0)
            return false;
        // Disable the right-panel show5x5Grid toggle until a real number frame is
        // selected (the initial "Number Frames" click selects a `_dummyForRightTool`
        // placeholder — same pattern as the `outline` and token-setting gating
        // elsewhere in this file), and for frames with 5 or fewer rows/cols where
        // the overlay would be redundant. Mirrors the disabledElements rule
        // GameController's collapsibleDivObject applies to the Toolbox version of
        // this same button.
        if (_id === 'show5x5Grid' && id === 'rightSideToolPanel') {
            var selectedFrame = manipulative.find(function (m) { var _a; return m.data.type === 'numberFrames' && selectedTool.includes((_a = m.data.id) !== null && _a !== void 0 ? _a : ''); });
            if (!selectedFrame)
                return true;
            var nf = selectedFrame.data;
            if (nf.rows <= 5 && nf.cols <= 5)
                return true;
        }
        var _bool = false;
        // Disable math text when table is selected at table-level (no cell focused)
        if (_id === 'mathtext') {
            var tableEntry = selectedTool.find(function (t) { return t.startsWith('tableText_'); });
            if (tableEntry && tableEntry.split('_').length < 4) {
                return true;
            }
        }
        // Disable tab button when table is selected at table-level (no cell focused)
        if (_id === 'tableTab') {
            var tableEntry = selectedTool.find(function (t) { return t.startsWith('tableText_'); });
            if (tableEntry && tableEntry.split('_').length < 4) {
                return true;
            }
        }
        // Disable delete button when editing or position is locked, cells are selected,
        // or any cell in the table has a content lock
        if (_id === 'delete') {
            var lockArray = contentLockArray();
            if (lockArray[0] || lockArray[1] || selectModeActive) {
                return true;
            }
            var hasLockedTable = selectedTool
                .filter(function (t) { return t.startsWith('tableText_'); })
                .some(function (t) {
                var _a, _b, _c;
                var tableIdx = parseInt(t.split('_')[1]);
                return (_c = (_b = (_a = table[tableIdx]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.cellData) === null || _c === void 0 ? void 0 : _c.some(function (c) { var _a, _b; return (_b = (_a = c === null || c === void 0 ? void 0 : c.data) === null || _a === void 0 ? void 0 : _a.lock) === null || _b === void 0 ? void 0 : _b.editing; });
            });
            if (hasLockedTable)
                return true;
        }
        // Shuffle applies to every deck object in the selection at once (deck A + deck
        // B shuffles both), and — like Flip/Restack — doesn't care which deck any
        // selected dealt cards belong to. It is enabled whenever at least one deck is
        // selected (alone, with other decks, or with any dealt cards regardless of
        // their owning deck), provided every selected deck still has more than one
        // undealt card. It is disabled when no deck is selected at all (cards
        // selected alone, however many, never enable it), when any selected deck has
        // `unplacedCount <= 1`, or when anything outside the deck/card pair is mixed
        // into the selection.
        if (_id === 'suffle' && id === 'rightSideToolPanel') {
            var deckIds = selectedTool.filter(function (t) { return t.startsWith('deck_'); });
            var others = selectedTool.filter(function (t) { return !t.startsWith('deck_') && !t.startsWith('card_'); });
            if (others.length > 0 || deckIds.length === 0) {
                return true;
            }
            var deckItems = deckIds
                .map(function (deckId) { return manipulative.find(function (item) { return item.data.id === deckId; }); })
                .filter(function (item) { return !!item; });
            if (deckItems.length !== deckIds.length) {
                return true;
            }
            return deckItems.some(function (deckItem) {
                var unplacedCount = deckItem.data.cards.filter(function (card) { return !card.placedOnDeck; }).length;
                return unplacedCount <= 1;
            });
        }
        // Flip and Restack act only on selected dealt cards — a selected deck itself
        // does nothing for either action, and it doesn't matter which deck a selected
        // card belongs to (flip/restack apply per-card, not per-deck). So both are
        // enabled whenever at least one card is selected, regardless of which decks
        // (if any) are also selected, and disabled when no card is selected at all
        // (deck(s) only, or nothing) or something unrelated is mixed in.
        // 'flip' is also dispatched for CoinsAndCounters (right-click Flip), so this
        // only applies when the selection actually involves a card deck/card — a
        // pure coin selection falls through to the generic handling below unaffected.
        if ((_id === 'flip' || _id === 'stack') &&
            id === 'rightSideToolPanel' &&
            selectedTool.some(function (t) { return t.startsWith('card_') || t.startsWith('deck_'); })) {
            var cardIds = selectedTool.filter(function (t) { return t.startsWith('card_'); });
            var others = selectedTool.filter(function (t) { return !t.startsWith('deck_') && !t.startsWith('card_'); });
            return others.length > 0 || cardIds.length === 0;
        }
        selectedTool.forEach(function (toolId) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            // console.log(toolId, _id, id, '%%%% items');
            if (toolId.startsWith('deck_') && id === 'rightSideToolPanel') {
                if (_id !== 'suffle') {
                    _bool = true;
                }
            }
            if (toolId.startsWith('card_') && id === 'rightSideToolPanel') {
                if (_id !== 'suffle') {
                    _bool = _bool || false;
                }
            }
            if (toolId.startsWith('numberChart_') &&
                (_id === 'replay' || _id === 'exitGames') &&
                id === 'rightSideToolPanel') {
                var items = manipulative.find(function (item) { return item.data.id === toolId; });
                if (((_a = items === null || items === void 0 ? void 0 : items.data) === null || _a === void 0 ? void 0 : _a.rows) < 5 || ((_b = items === null || items === void 0 ? void 0 : items.data) === null || _b === void 0 ? void 0 : _b.columns) < 5) {
                    _bool = true;
                }
            }
            // Disable replay and exitGames if no game mode is selected
            if (toolId.startsWith('numberChart_') &&
                (_id === 'replay' || _id === 'exitGames') &&
                id === 'rightSideToolPanel') {
                var items = manipulative.find(function (item) { return item.data.id === toolId; });
                var chartData = items === null || items === void 0 ? void 0 : items.data;
                if (!(chartData === null || chartData === void 0 ? void 0 : chartData.isGameMode)) {
                    _bool = true;
                }
            }
            // Disable stampEraser and stampEraserAll if selected numberChart has no stamps
            if (toolId.startsWith('numberChart_') &&
                (_id === 'stampEraser' || _id === 'stampEraserAll') &&
                id === 'rightSideToolPanel') {
                var items = manipulative.find(function (item) { return item.data.id === toolId; });
                if (items) {
                    var chartData = items.data;
                    // Check if any cell has stamps (iconIndex array with elements)
                    var hasStamps = (_c = chartData.cells) === null || _c === void 0 ? void 0 : _c.some(function (row) {
                        return row.some(function (cell) { return cell.iconIndex && cell.iconIndex.length > 0; });
                    });
                    if (!hasStamps) {
                        _bool = true;
                    }
                }
            }
            // Clock geared-only tools (digitalDisplay, runAndJump, elapsedTime) are always enabled.
            // AnalogClock.tsx shows a popup alert when clicked on non-geared clocks.
            if (toolId.startsWith('numberRacks_') && id === 'rightSideToolPanel') {
                var items = manipulative.find(function (item) { return item.data.id === toolId; });
                if (items) {
                    var rods = items.data.rods;
                    if (_id === 'addRow')
                        _bool = _bool || rods.length >= 10;
                    if (_id === 'removeRow')
                        _bool = _bool || rods.length <= 1;
                    if (_id === 'reverseBeads')
                        _bool = _bool || rods.length <= 5;
                }
            }
            // Disable addRow, addColumn, toggleExpression, toggleProduct for open arrays
            if (toolId.startsWith('arrayModel_') && id === 'rightSideToolPanel') {
                var items = manipulative.find(function (item) { return item.data.id === toolId; });
                if (items && items.data.mode === 'open') {
                    if (_id === 'addRow' ||
                        _id === 'addColumn' ||
                        _id === 'toggleExpression' ||
                        _id === 'toggleProduct') {
                        _bool = true;
                    }
                }
                if (items && _id === 'partMode' && ((_d = items.data.lock) === null || _d === void 0 ? void 0 : _d.editing)) {
                    _bool = true;
                }
            }
            if (toolId.startsWith('numberLine_') && id === 'rightSideToolPanel') {
                var nlData = (_e = manipulative.find(function (item) { return item.data.id === toolId; })) === null || _e === void 0 ? void 0 : _e.data;
                if (_id === 'lineMasking' && (nlData === null || nlData === void 0 ? void 0 : nlData.lineMode) === 'noTickMarks') {
                    _bool = true;
                }
                if (_id === 'maskAll') {
                    var hasMaskedLine = (nlData === null || nlData === void 0 ? void 0 : nlData.lineMode) !== 'noTickMarks';
                    var isMasking = hasMaskedLine && !(nlData === null || nlData === void 0 ? void 0 : nlData.labelsVisible);
                    var hasRevealedLabels = ((_g = (_f = nlData === null || nlData === void 0 ? void 0 : nlData.unmaskedLabels) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) > 0;
                    if (!isMasking || !hasRevealedLabels)
                        _bool = true;
                }
                if (_id === 'jumpLabel') {
                    var hasJumpBars = manipulative.some(function (m) { return m.data.numberLineId === toolId; });
                    if (!hasJumpBars)
                        _bool = true;
                }
            }
            // Resolve a coloredTiles tile by direct ID, or by groupId when a manipulativeGroup
            // of coloredTiles (with optional linearPiece accessories) is selected — so add/remove
            // row/column can be disabled in both cases.
            var isColoredTilesGroup = toolId.startsWith('manipulativeGroup_') &&
                (function () {
                    var members = manipulative.filter(function (m) { return m.data.groupId === toolId; });
                    return (members.some(function (m) { return m.data.type === 'coloredTiles'; }) &&
                        members.every(function (m) { return m.data.type === 'coloredTiles' || m.data.type === 'linearPiece'; }));
                })();
            if ((toolId.startsWith('coloredTiles_') || isColoredTilesGroup) &&
                id === 'rightSideToolPanel') {
                var items = toolId.startsWith('coloredTiles_')
                    ? manipulative.find(function (item) { return item.data.id === toolId; })
                    : manipulative.find(function (item) { return item.data.groupId === toolId && item.data.type === 'coloredTiles'; });
                // Disable all tile-operating buttons when no real tile is found OR when
                // the tile is the invisible placeholder (isInvisible: true) created when
                // manual mode forces the right panel open before any real block is placed.
                // The color-tray (`blocks`) and `linearPieces` are creation tools and stay enabled.
                var tileOperatingButtons = [
                    'addRow',
                    'addColumn',
                    'removeRow',
                    'removeColumn',
                    'addAllVertical',
                    'addAllHorizontal',
                    'toggleExpression',
                    'toggleProduct',
                    'dimensionLabels',
                    'partMode',
                    'selectMode',
                    'groupVertical',
                    'groupHorizontal',
                ];
                var isInvisiblePlaceholder = !!((_h = items === null || items === void 0 ? void 0 : items.data) === null || _h === void 0 ? void 0 : _h.isInvisible);
                if ((!items || isInvisiblePlaceholder) && tileOperatingButtons.includes(_id)) {
                    _bool = true;
                }
                if (items) {
                    var tileData = items.data;
                    var isManualNonGroupTile = tileData.generationMode === 'manual' && !tileData.isGroup;
                    var invalidRectangle = !isProperRectangle(tileData);
                    var expressionControls = ['toggleExpression', 'toggleProduct'];
                    var addRemoveControls = ['addRow', 'addColumn'];
                    var allControls = __spreadArray(__spreadArray(__spreadArray([], expressionControls, true), addRemoveControls, true), ['partMode'], false);
                    // Buttons that require a fully solid rectangle (all cells colored).
                    // selectMode is handled separately: it only needs ≥1 colored cell, not a full rectangle.
                    var rectRequiredControls = __spreadArray(__spreadArray([], allControls, true), [
                        'dimensionLabels',
                        'groupVertical',
                        'groupHorizontal',
                    ], false);
                    var hasNoColoredCells = Object.keys((_j = tileData.partColors) !== null && _j !== void 0 ? _j : {}).length === 0;
                    var isSingleCell = tileData.rows * tileData.columns <= 1;
                    // Outline: addRow/addColumn disabled when invalid rectangle;
                    // selectMode disabled when no cells colored; partMode disabled for 1×1 grid
                    if (tileData.generationMode === 'outline') {
                        if (invalidRectangle && addRemoveControls.includes(_id)) {
                            _bool = true;
                        }
                        if (_id === 'selectMode' && hasNoColoredCells) {
                            _bool = true;
                        }
                        if (_id === 'partMode' && isSingleCell) {
                            _bool = true;
                        }
                    }
                    if ((tileData.rows === 1 && _id === 'removeRow') ||
                        (tileData.columns === 1 && _id === 'removeColumn')) {
                        _bool = true;
                    }
                    // When the tile is part of a multi-tile group (data.groupId is set),
                    // row/column add/remove and Select Part must be disabled — those operations
                    // would change the bounding rect or selection state of just one group member
                    // and tear the layout apart.
                    if (tileData.groupId &&
                        [
                            'addRow',
                            'addColumn',
                            'removeRow',
                            'removeColumn',
                            'selectMode',
                            'addAllVertical',
                            'addAllHorizontal',
                        ].includes(_id)) {
                        _bool = true;
                    }
                    // Manual: rect-required controls disabled until solid rectangle;
                    // selectMode only disabled when no cells colored yet;
                    // partMode disabled for single-cell tiles (nothing to divide)
                    if (isManualNonGroupTile) {
                        if (rectRequiredControls.includes(_id) && invalidRectangle) {
                            _bool = true;
                        }
                        if (_id === 'selectMode' && hasNoColoredCells) {
                            _bool = true;
                        }
                        if (_id === 'partMode' && isSingleCell) {
                            _bool = true;
                        }
                    }
                    // Random: rect-required controls disabled when invalid rectangle;
                    // selectMode only disabled when no cells colored yet;
                    // partMode disabled for single-cell tiles
                    if (tileData.generationMode === 'random') {
                        if (invalidRectangle && rectRequiredControls.includes(_id)) {
                            _bool = true;
                        }
                        if (_id === 'selectMode' && hasNoColoredCells) {
                            _bool = true;
                        }
                        if (_id === 'partMode' && isSingleCell) {
                            _bool = true;
                        }
                    }
                }
            }
        });
        // Disable tile-specific buttons when only linearPiece(s) selected (no coloredTile in selection).
        // A manipulativeGroup_ id must be resolved to its members' types — the literal id itself
        // never starts with 'linearPiece_'/'coloredTiles_' (mirrors isColoredTilesGroup above).
        if (id === 'rightSideToolPanel') {
            var groupMemberTypes_1 = function (toolId) {
                return toolId.startsWith('manipulativeGroup_')
                    ? manipulative.filter(function (m) { return m.data.groupId === toolId; }).map(function (m) { return m.data.type; })
                    : [];
            };
            var hasLinearPiece = selectedTool.some(function (t) { return t.startsWith('linearPiece_'); }) ||
                selectedTool.some(function (t) { return groupMemberTypes_1(t).includes('linearPiece'); });
            var hasColoredTile = selectedTool.some(function (t) { return t.startsWith('coloredTiles_'); }) ||
                selectedTool.some(function (t) { return groupMemberTypes_1(t).includes('coloredTiles'); });
            if (hasLinearPiece && !hasColoredTile) {
                var tileOnlyButtons = ['groupColumn', 'groupRow', 'addColumn', 'removeColumn', 'addRow', 'removeRow', 'addAllVertical', 'addAllHorizontal', 'toggleExpression', 'toggleProduct', 'dimensionLabels', 'partMode', 'selectMode'];
                if (tileOnlyButtons.includes(_id))
                    _bool = true;
            }
        }
        // Resolve selected IDs to actual pieces (expand group IDs to members).
        // Use stableManipulative so panel content doesn't flicker during chunk inserts.
        var resolvedPieces = selectedTool.flatMap(function (sid) {
            if (sid.startsWith('manipulativeGroup_')) {
                return stableManipulative.filter(function (item) { return item.data.groupId === sid; });
            }
            var m = stableManipulative.find(function (item) { return item.data.id === sid; });
            return m ? [m] : [];
        });
        // Disable all NMP actions when only a dummy is selected (no real piece)
        var dummyForRightTool = selectedTool.length > 0 && selectedTool.every(function (t) { return t.endsWith('_dummyForRightTool'); });
        if (dummyForRightTool && id === 'rightSideToolPanel') {
            if (NMP_ANIMATING_ACTIONS.some(function (a) { return isNmpAction(_id, a); })) {
                _bool = true;
            }
        }
        // Disable break if no selected numberPiece is breakable (not ones)
        if (isNmpAction(_id, 'nmp_break') && id === 'rightSideToolPanel') {
            var hasBreakable = resolvedPieces.some(function (m) { return m.data.type === 'numberPiece' && m.data.denomination !== 'ones'; });
            if (!hasBreakable)
                _bool = true;
        }
        // Disable link if no denomination has 10+ selected pieces (ones/tens only, hundreds can't link)
        if (isNmpAction(_id, 'nmp_link') && id === 'rightSideToolPanel') {
            var denomCounts_1 = {};
            resolvedPieces.forEach(function (m) {
                if (m.data.type === 'numberPiece') {
                    var denom = m.data.denomination;
                    if (denom !== 'hundreds') {
                        denomCounts_1[denom] = (denomCounts_1[denom] || 0) + 1;
                    }
                }
            });
            var canLink = Object.values(denomCounts_1).some(function (c) { return c >= 10; });
            if (!canLink)
                _bool = true;
        }
        // Disable rotate if no selected piece is non-square. Rotatable pieces:
        //   numberPiece tens (1×10), moneyPiece dime (1×10), moneyPiece nickel (1×5),
        //   moneyPiece halfDollar (5×10).
        // ones/hundreds/dollar/quarter/penny are square — no rotate.
        if (isNmpAction(_id, 'nmp_rotate') && id === 'rightSideToolPanel') {
            // A 2+ member NMP group can always rotate — every member's own
            // `center` rotates 90° around the group's centroid (see the
            // 'nmp_rotate' case in NumberAndMoneyPieceManipulative.tsx), even
            // when every member is a square (non-individually-rotatable) piece.
            var isMultiMemberGroup = !!((_a = resolvedPieces[0]) === null || _a === void 0 ? void 0 : _a.data.groupId) && resolvedPieces.length >= 2;
            var canRotate = isMultiMemberGroup ||
                resolvedPieces.some(function (m) {
                    if (m.data.type === 'numberPiece') {
                        return m.data.denomination === 'tens';
                    }
                    if (m.data.type === 'moneyPiece') {
                        var d = m.data.denomination;
                        return d === 'dime' || d === 'nickel' || d === 'halfDollar';
                    }
                    return false;
                });
            if (!canRotate)
                _bool = true;
        }
        // Disable NMP action buttons while animation is in progress.
        // Uses the ticker singleton (set at t=0, cleared at t=3.1s) instead of scanning
        // the manipulative array — BottomPanel re-evaluates exactly twice per animation.
        if (NMP_ANIMATING_ACTIONS.some(function (a) { return isNmpAction(_id, a); }) && id === 'rightSideToolPanel') {
            if (nmpAnimationTicker.isAnimating)
                _bool = true;
        }
        // Disable flip if no moneyPiece is selected — flip only applies to money
        // pieces (coins / bills). Without this guard the button looks dimmed but
        // remains Tab-focusable when the selection has no money pieces.
        if (isNmpAction(_id, 'nmp_flip') && id === 'rightSideToolPanel') {
            var hasMoneyPiece = resolvedPieces.some(function (m) { return m.data.type === 'moneyPiece'; });
            if (!hasMoneyPiece)
                _bool = true;
        }
        // Disable exchange if no moneyPiece selected, mixed pieceTypes, or no valid exchange target
        if (isNmpAction(_id, 'nmp_exchange') && id === 'rightSideToolPanel') {
            var moneyItems = resolvedPieces.filter(function (m) { return m.data.type === 'moneyPiece'; });
            if (moneyItems.length === 0) {
                _bool = true;
            }
            else {
                var pieceTypes = new Set(moneyItems.map(function (m) { return m.data.pieceType; }));
                if (pieceTypes.size > 1) {
                    _bool = true;
                }
                else {
                    var exchangeTool = toolsBtn.find(function (tb) { return isNmpAction(tb.id, 'nmp_exchange'); });
                    var elems = ((exchangeTool === null || exchangeTool === void 0 ? void 0 : exchangeTool.elements) || []);
                    var valueMap_1 = Object.fromEntries(elems.map(function (el) { return [el.id, el.value]; }));
                    var totalCents_1 = moneyItems.reduce(function (sum, m) { return sum + (valueMap_1[m.data.denomination] || 0); }, 0);
                    var denomCounts_2 = {};
                    moneyItems.forEach(function (m) {
                        var d = m.data.denomination;
                        denomCounts_2[d] = (denomCounts_2[d] || 0) + 1;
                    });
                    var currentDenoms_1 = new Set(Object.keys(denomCounts_2));
                    var allSameDenom_1 = currentDenoms_1.size === 1;
                    var hasValidTarget = elems.some(function (el) {
                        var resultCount = Math.floor(totalCents_1 / el.value);
                        var canAfford = resultCount > 0;
                        var isSameDenom = allSameDenom_1 && currentDenoms_1.has(el.id);
                        var noChange = canAfford && resultCount === (denomCounts_2[el.id] || 0);
                        return canAfford && !isSameDenom && !noChange;
                    });
                    if (!hasValidTarget)
                        _bool = true;
                }
            }
        }
        // Disable fractionOverlayShading when no selected clock has a fraction overlay
        if (_id === 'fractionOverlayShading') {
            var selectedClocks = selectedTool.filter(function (sid) { return sid.startsWith('analog_clock_'); });
            var anyHasOverlay = selectedClocks.some(function (sid) {
                var m = stableManipulative.find(function (item) { return item.data.id === sid; });
                return m && m.data.fractionOverlayParts != null;
            });
            if (!anyHasOverlay)
                _bool = true;
        }
        return _bool;
    };
    var renderComponents = function (tool, index, isElementDisabled) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        // SVG image map for pattern shape sidebar buttons (exported from XD)
        var patternShapeSvgMap = {
            triangle_equilateral: './assets/images/manipulative/patternShape/Triangle.svg',
            triangle_right: './assets/images/manipulative/patternShape/90 triangle.svg',
            square: './assets/images/manipulative/patternShape/Sequare.svg',
            rhombus_blue: './assets/images/manipulative/patternShape/Rhombus.svg',
            trapezoid: './assets/images/manipulative/patternShape/Trapezium.svg',
            rhombus_white: './assets/images/manipulative/patternShape/RhombusThin.svg',
            hexagon: './assets/images/manipulative/patternShape/Hexagone.svg',
        };
        if (id === 'rightSideToolPanel' &&
            typeof (tool === null || tool === void 0 ? void 0 : tool.id) === 'string' &&
            patternShapeSvgMap[tool.id]) {
            var shapeKey_1 = tool.id;
            var shapeHovered = hoveredShapeTools[tool.id] || false;
            return (_jsxs("div", { className: "buttonWrapper", style: { position: 'relative' }, 
                // Skip on coarse-pointer (touch) devices — a tap synthesizes a
                // mouseenter but doesn't reliably fire mouseleave, which leaves
                // the tooltip stuck open over the shape icon.
                onMouseEnter: function () {
                    return !IS_COARSE_POINTER && setHoveredShapeTools(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[tool.id] = true, _a)));
                    });
                }, onMouseLeave: function () { return setHoveredShapeTools(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[tool.id] = false, _a)));
                }); }, children: [_jsx("button", { className: "toolBtn patternShapeBtn ".concat(tool.className || ''), "aria-label": t(tool.ariaLabel), onMouseDown: function (e) { return handlePatternShapeMouseDown(e, shapeKey_1); }, onTouchStart: function (e) { return handlePatternShapeMouseDown(e, shapeKey_1); }, onClick: function (e) { if (e.detail === 0 && Date.now() - lastPatternTouchRef.current >= 500)
                            customEventHandler.dispatchEvent('bottomPanel', { id: shapeKey_1, type: 'btn' }); }, children: _jsx("img", { src: getImageSrc(patternShapeSvgMap[tool.id]), alt: "", draggable: "false" }) }), shapeHovered && (_jsx(ToolTip, { buttonHovered: shapeHovered, text: t(tool.ariaLabel), direction: commonDirection, toolTipCSS: commonToolTipCSS, isParentRelative: commonIsRelative, isWhiteBoard: useWhiteBoardMode }))] }, "".concat(tool.id, "_").concat(index)));
        }
        if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'imageBtn' || (tool === null || tool === void 0 ? void 0 : tool.type) === 'btn' || (tool === null || tool === void 0 ? void 0 : tool.type) === undefined) {
            var _bool = false;
            if (id === 'rightSideToolPanel' || id === 'toolBottomPanel' || id === 'bottomPanelTool') {
                _bool = (_b = (_a = collapsibleState.find(function (item) { return item.id === tool.id; })) === null || _a === void 0 ? void 0 : _a.isActive) !== null && _b !== void 0 ? _b : undefined;
            }
            if (tool.id === 'select') {
                _bool = selectModeActive;
            }
            if (['bold', 'italic', 'underline', 'leftAlign', 'centerAlign', 'rightAlign'].includes(tool.id)) {
                _bool = (_c = formattingActive[tool.id]) !== null && _c !== void 0 ? _c : false;
            }
            var handleFormattingMouseDown = function (e) {
                if (SELECTION_PRESERVING_IDS.has(tool.id)) {
                    e.preventDefault();
                }
            };
            return (_jsxs("div", { className: "buttonWrapper ".concat(isRightPanel ? tool.id : '', " ").concat(isRightPanel && tool.title ? 'iconBtnWrapper' : ''), children: [isRightPanel && tool.title && (_jsx("div", { className: "iconBtnLabel", "aria-hidden": "true", children: t(tool.title) })), _jsx("div", { style: commonIsRelative ||
                            selectedTool.some(function (t) { return typeof t === 'string' && (t.includes('tableText') || t.startsWith('text_')); })
                            ? { position: 'relative' }
                            : {}, children: _jsx(ButtonComponent, { imgSrc: tool.imgSrc, defaultCSS: "toolBtn ".concat(tool.className), normalCSS: "toolBtn", ariaHidden: isRightPanel && btnDisable(tool.id) ? true : undefined, ariaLabel: t(tool.ariaLabel), clickActive: tool === null || tool === void 0 ? void 0 : tool.activeState, controlActiveFromOutside: tool === null || tool === void 0 ? void 0 : tool.activeState, isActive: _bool && !btnDisable(tool.id), ariaPressed: ['bold', 'italic', 'underline', 'leftAlign', 'centerAlign', 'rightAlign'].includes(tool.id)
                                ? ((_d = formattingActive[tool.id]) !== null && _d !== void 0 ? _d : false)
                                : undefined, 
                            // The Math Keypad button opens the math keypad toolbar, so it must
                            // advertise that it controls a popup and whether it is currently
                            // open. `_bool` above already tracks the keypad's visibility for
                            // this button via collapsibleState, so there is no new state here.
                            ariaHaspopup: tool.id === 'mathtext' ? true : undefined, ariaExpanded: tool.id === 'mathtext' ? !!_bool : undefined, text: tool.text, label: tool.label ? t(tool.label) : undefined, 
                            // imgWidth={20}
                            title: tool.ariaLabel || tool.title, showToolTip: true, direction: commonDirection, isParentRelative: commonIsRelative ||
                                selectedTool.some(function (t) { return typeof t === 'string' && (t.includes('tableText') || t.startsWith('text_')); }), isWhiteBoard: useWhiteBoardMode, onMouseDown: DRAG_TO_CREATE_IDS.has(tool.id)
                                ? function (e) { return handleDragToCreate(e, tool.id); }
                                : handleFormattingMouseDown, onTouchStart: DRAG_TO_CREATE_IDS.has(tool.id)
                                ? function (e) { return handleDragToCreate(e, tool.id); }
                                : SELECTION_PRESERVING_IDS.has(tool.id)
                                    ? function (e) { return e.preventDefault(); }
                                    : undefined, clickHandler: function () {
                                if (dragToCreateRef.current)
                                    return;
                                closeManipulatorPopup();
                                // Keyboard activation for NMP denomination buttons. The
                                // per-piece widget listener that handles "create duplicate
                                // on tool click" only fires when a real piece is selected;
                                // when only the right-panel dummy selection (or nothing) is
                                // active, that listener won't run. Create the piece here at
                                // canvas viewport center so Enter/Space on a denomination
                                // button reliably places a piece on the canvas.
                                if (DRAG_TO_CREATE_IDS.has(tool.id)) {
                                    // Real NMP selection means a piece on the canvas is selected
                                    // (or a group containing one). We must exclude the right-panel
                                    // dummy entries (`<configKey>_dummyForRightTool`) here — they
                                    // also start with `numberPiece_` / `moneyPiece_` and would
                                    // otherwise hide the dummy-only state behind which the widget
                                    // listener is not registered, so the bottomPanel event would
                                    // be dispatched into the void.
                                    var hasRealNmpSelection = selectedTool.some(function (sid) {
                                        return !sid.endsWith('_dummyForRightTool') &&
                                            (sid.startsWith('numberPiece_') ||
                                                sid.startsWith('moneyPiece_') ||
                                                sid.startsWith('manipulativeGroup_'));
                                    });
                                    if (!hasRealNmpSelection) {
                                        var canvasEl = document.querySelector('.whiteboardScrollbar .customScrollbarContent');
                                        if (canvasEl) {
                                            var z = zoomLevel || 1;
                                            var rect = canvasEl.getBoundingClientRect();
                                            var cx = (canvasEl.scrollLeft + rect.width / 2) / z;
                                            var cy = (canvasEl.scrollTop + rect.height / 2) / z;
                                            createNmpPieceAt(tool.id, cx, cy, true);
                                            return;
                                        }
                                    }
                                }
                                customEventHandler.dispatchEvent('bottomPanel', {
                                    panel: 'bottomPanel',
                                    id: tool.id,
                                    type: tool.type,
                                });
                            }, disabled: btnDisable(tool.id), tabIndex: disableTabFocus ? -1 : undefined }, "".concat(tool.id, "_").concat(index)) })] }, "wrapper_".concat(tool.id, "_").concat(index)));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'toggleBtn') {
            if (tool.options) {
                return (_jsxs("div", { className: "toggleBtnWrapper ".concat(tool.id), "aria-hidden": isRightPanel && btnDisable(tool.id) ? true : undefined, onMouseEnter: function () {
                        return !IS_COARSE_POINTER && setHoveredShapeTools(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[tool.id] = true, _a)));
                        });
                    }, onMouseLeave: function () { return setHoveredShapeTools(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[tool.id] = false, _a)));
                    }); }, children: [tool.title && (_jsx("div", { className: "toggleTitle", "aria-hidden": "true", children: t(tool.title) })), _jsx(ToggleButton, { initial: (_g = (_e = tool.defaultValue) !== null && _e !== void 0 ? _e : (_f = tool.options[0]) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : 'On', 
                            // Fold the toggle's title into each option's aria-label so the
                            // screen reader reads e.g. "Show Expression On" / "Show Expression
                            // Off" directly on the option (a bare group aria-label / labelledby
                            // isn't reliably read for a button-group toggle). The visible text
                            // ("On"/"Off") is unaffected — it uses valueVisible/value.
                            options: tool.options.map(function (opt) {
                                var _a, _b;
                                return (__assign(__assign({}, opt), { ariaLabel: tool.title
                                        ? "".concat(t(tool.title), " ").concat(t((_b = (_a = opt.ariaLabel) !== null && _a !== void 0 ? _a : opt.value) !== null && _b !== void 0 ? _b : ''))
                                        : opt.ariaLabel }));
                            }), textVisible: true, ariaLabel: t(tool.ariaLabel), disabled: btnDisable(tool.id), onChange: function () {
                                // Guard against StrictMode double-fire (setState updater runs twice)
                                if (toggleGuardRef.current[tool.id])
                                    return;
                                toggleGuardRef.current[tool.id] = true;
                                Promise.resolve().then(function () {
                                    toggleGuardRef.current[tool.id] = false;
                                });
                                closeManipulatorPopup();
                                customEventHandler.dispatchEvent('bottomPanel', {
                                    panel: 'bottomPanel',
                                    id: tool.id,
                                    type: tool.type,
                                });
                            } }), hoveredShapeTools[tool.id] && (_jsx(ToolTip, { buttonHovered: hoveredShapeTools[tool.id], text: t(tool.ariaLabel), direction: commonDirection, toolTipCSS: commonToolTipCSS, isParentRelative: commonIsRelative, isWhiteBoard: useWhiteBoardMode }))] }, tool.id));
            }
            return _jsx(ToggleButton, {});
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'lockBtn') {
            return (_jsxs("div", { className: "lockBtnWrapper", children: [_jsx(ButtonComponent, { imgSrc: tool.imgSrc, defaultCSS: 'toolBtn', normalCSS: "toolBtns", ariaLabel: t(tool.ariaLabel), isActive: cellContentLocked || contentLockArray()[0] || contentLockArray()[1], controlActiveFromOutside: true, title: tool.ariaLabel, showToolTip: true, direction: commonDirection, isParentRelative: commonIsRelative, isWhiteBoard: useWhiteBoardMode, clickHandler: function () {
                            closeManipulatorPopup();
                            var isTable = selectedTool.some(function (t) { return t.startsWith('tableText_') || t.startsWith('numberFrame_'); });
                            var isPatternShapes = selectedTool.some(function (t) { return t.startsWith('patternShapes_'); });
                            var isCoinsAndCounters = selectedTool.some(function (t) { return t.startsWith('coinsAndCounters_'); });
                            if (isTable) {
                                setShowLock(!showLock);
                            }
                            else if (isPatternShapes) {
                                toggleLockState(0); // Toggle positioning lock for pattern shapes
                            }
                            else if (isCoinsAndCounters) {
                                toggleLockState(0); // Coins & Counters: lock = pin in place (positioning)
                            }
                            else {
                                toggleLockState(1); // Directly toggle position lock for non-table manipulatives
                            }
                        } }), showLock &&
                        selectedTool.some(function (t) { return t.startsWith('tableText_') || t.startsWith('numberFrame_'); }) && (_jsx("div", { className: "lockUnlockContainer", children: tool.elements &&
                            tool.elements.map(function (opt, index) { return (_jsxs("div", { children: [_jsxs("div", { className: "container", children: [_jsx("div", { children: t(opt.title) }), _jsx(FlipButton, { tool: opt, defaultCSS: "toolBtn", normalCSS: "toolBtns", active: (function () {
                                                    var _a, _b, _c, _d;
                                                    var tableEntry = selectedTool.find(function (t) { return t.startsWith('tableText_'); });
                                                    if (tableEntry) {
                                                        if (index === 0 && selectModeActive)
                                                            return cellContentLocked;
                                                        var tblIdx = Number(tableEntry.split('_')[1]);
                                                        var tbl = table[tblIdx];
                                                        return index === 0
                                                            ? (((_b = (_a = tbl === null || tbl === void 0 ? void 0 : tbl.data) === null || _a === void 0 ? void 0 : _a.cellData) === null || _b === void 0 ? void 0 : _b.length) > 0 && tbl.data.cellData.every(function (c) { var _a, _b; return ((_b = (_a = c === null || c === void 0 ? void 0 : c.data) === null || _a === void 0 ? void 0 : _a.lock) === null || _b === void 0 ? void 0 : _b.editing) === true; }))
                                                            : (((_d = (_c = tbl === null || tbl === void 0 ? void 0 : tbl.data) === null || _c === void 0 ? void 0 : _c.lock) === null || _d === void 0 ? void 0 : _d.positioning) || false);
                                                    }
                                                    return index === 0
                                                        ? cellContentLocked || contentLockArray()[0]
                                                        : contentLockArray()[index];
                                                })(), onClick: function () { return toggleLockState(index); }, disabled: !isAdmin || (index === 1 && (function () {
                                                    var _a, _b;
                                                    var te = selectedTool.find(function (t) { return t.startsWith('tableText_'); });
                                                    if (!te)
                                                        return false;
                                                    if (te.split('_').length >= 4)
                                                        return true;
                                                    var tblIdx = Number(te.split('_')[1]);
                                                    return ((_b = (_a = table[tblIdx]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.cellSelectMode) === true;
                                                })()) }, opt.id)] }), (tool.elements || []).length - 1 > index && _jsx("hr", { className: "verticleLine" })] }, index)); }) }))] }, tool.id));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'flipBtn') {
            return (_jsx(FlipButton, { tool: tool, defaultCSS: "toolBtn", normalCSS: "toolBtns", active: flipBtnBool() || Boolean(tool === null || tool === void 0 ? void 0 : tool.activeState), onClick: function () {
                    closeManipulatorPopup();
                    customEventHandler.dispatchEvent('bottomPanel', { id: tool.id, type: tool.type });
                }, showToolTip: true, direction: commonDirection, isParentRelative: commonIsRelative, isWhiteBoard: useWhiteBoardMode, disabled: btnDisable(tool.id) }));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'collapsibleBtn') {
            // Use CSS positioning for table toolbars - detect if table cell is selected
            var isTableToolbar = selectedTool.some(function (item) { return typeof item === 'string' && item.includes('tableText'); });
            var collapsible = (_jsx(CollapsibleDiv, { elements: tool.elements || [], mainElement: tool.imgSrc, onSelect: function (data) {
                    closeAllPopups();
                    closeManipulatorPopup();
                    customEventHandler.dispatchEvent('bottomPanel', {
                        panel: 'bottomPanel',
                        id: tool.id,
                        type: tool.type,
                        data: data,
                    });
                }, collapsibleContainerCSS: "_btnHolder", mainEleDefaultCSS: "collapsibleMainElement", elemsDefaultCSS: 'collapsibleOptionElem', 
                // openAt={isRightPanel ? 'left' : 'bottom'}
                // direction={isRightPanel ? 'left' : 'bottom'}
                openAt: collapsibleDirection, direction: commonDirection, isParentRelative: true, isTooltipRelative: isTableToolbar, title: tool.title, ariaLabel: tool.ariaLabel, showToolTip: true, zoomLevel: zoomLevel, isWhiteBoard: useWhiteBoardMode, useCSSPositioning: isTableToolbar, type: "imageType1", activeElements: (_j = (_h = collapsibleState.find(function (item) { return item.id === tool.id; })) === null || _h === void 0 ? void 0 : _h.activeElements) !== null && _j !== void 0 ? _j : undefined }));
            return isTableToolbar ? (_jsx("div", { style: { position: 'relative' }, children: collapsible })) : (collapsible);
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'linkBtn') {
            return (_jsxs("div", { className: "linkBtnWrapper", style: { position: 'relative' }, children: [_jsx(ButtonComponent, { imgSrc: tool.imgSrc, defaultCSS: "toolBtn", normalCSS: "toolBtn", ariaLabel: t(tool.ariaLabel), clickActive: tool === null || tool === void 0 ? void 0 : tool.activeState, 
                        // imgWidth={20}
                        title: tool.ariaLabel, showToolTip: true, direction: commonDirection, isParentRelative: commonIsRelative ||
                            selectedTool.some(function (t) { return typeof t === 'string' && (t.includes('tableText') || t.startsWith('text_')); }), isWhiteBoard: useWhiteBoardMode, disabled: btnDisable(tool.id), onMouseDown: function (e) {
                            // Prevent default to preserve text selection on iPad/touch devices
                            e.preventDefault();
                        }, clickHandler: function () {
                            var wasOpen = showLinkPopup;
                            closeAllPopups();
                            closeManipulatorPopup();
                            if (!wasOpen)
                                setshowLinkPopup(true);
                        } }, tool.id), showLinkPopup && (_jsx("div", { className: "linkContainer", onPointerDown: function (e) { return e.stopPropagation(); }, children: _jsx(InputBox, { id: "linkInput", normalCSS: "linkInput", onChange: linkInput, autoFocus: true }) }))] }));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'scaleBtn') {
            var leftBtn_1 = tool.elements && tool.elements[0];
            var rightBtn_1 = tool.elements && tool.elements[1];
            var currentScaleVal = calcScale();
            // Only disable scale buttons at min/max for pattern shapes
            var isPatternShapeSelected = selectedTool.some(function (s) {
                return s.startsWith('patternShapes_') ||
                    (s.startsWith('manipulativeGroup_') &&
                        stableManipulative
                            .filter(function (m) { return m.data.groupId === s; })
                            .every(function (m) { return m.data.type === 'patternShapes'; }));
            });
            var isMinusDisabled = isPatternShapeSelected && currentScaleVal <= 0.5;
            var isPlusDisabled = isPatternShapeSelected && currentScaleVal >= 5;
            return (_jsxs("div", { className: "scaleWrapper", children: [_jsx("span", { className: "scaleLabel", children: t('text.scale') }), _jsxs("div", { className: "scaleBtnWrapper", children: [_jsx(ButtonComponent, { defaultCSS: "scaleBtn", normalCSS: "scaleBtnNormal", imgSrc: leftBtn_1 === null || leftBtn_1 === void 0 ? void 0 : leftBtn_1.imgSrc, showToolTip: true, title: leftBtn_1 === null || leftBtn_1 === void 0 ? void 0 : leftBtn_1.title, direction: commonDirection, ariaLabel: leftBtn_1 === null || leftBtn_1 === void 0 ? void 0 : leftBtn_1.ariaLabel, isWhiteBoard: useWhiteBoardMode, disabled: isMinusDisabled, clickHandler: function () {
                                    closeAllPopups();
                                    closeManipulatorPopup();
                                    customEventHandler.dispatchEvent('bottomPanel', {
                                        panel: 'bottomPanel',
                                        id: leftBtn_1 === null || leftBtn_1 === void 0 ? void 0 : leftBtn_1.id,
                                        type: tool.type,
                                    });
                                } }, leftBtn_1 === null || leftBtn_1 === void 0 ? void 0 : leftBtn_1.id), _jsx("span", { className: "scaleVal", children: currentScaleVal }), _jsx(ButtonComponent, { defaultCSS: "scaleBtn", normalCSS: "scaleBtnNormal", imgSrc: rightBtn_1 === null || rightBtn_1 === void 0 ? void 0 : rightBtn_1.imgSrc, showToolTip: true, direction: "bottom", title: rightBtn_1 === null || rightBtn_1 === void 0 ? void 0 : rightBtn_1.title, ariaLabel: rightBtn_1 === null || rightBtn_1 === void 0 ? void 0 : rightBtn_1.ariaLabel, isWhiteBoard: useWhiteBoardMode, disabled: isPlusDisabled, clickHandler: function () {
                                    closeAllPopups();
                                    closeManipulatorPopup();
                                    customEventHandler.dispatchEvent('bottomPanel', {
                                        panel: 'bottomPanel',
                                        id: rightBtn_1 === null || rightBtn_1 === void 0 ? void 0 : rightBtn_1.id,
                                        type: tool.type,
                                    });
                                } }, rightBtn_1 === null || rightBtn_1 === void 0 ? void 0 : rightBtn_1.id)] })] }));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'groupedBtn') {
            var leftBtn_2 = tool.elements && tool.elements[0];
            var rightBtn_2 = tool.elements && tool.elements[1];
            var isGroupAllDisabled = (_k = tool.elements) === null || _k === void 0 ? void 0 : _k.every(function (el) { var _a; return btnDisable((_a = el.id) !== null && _a !== void 0 ? _a : ''); });
            return (_jsxs("div", { className: "groupedBtnWrapper", "aria-hidden": isRightPanel && isGroupAllDisabled ? true : undefined, children: [tool.title && _jsx("span", { className: "groupedBtnLabel", children: t(tool.title) }), _jsxs("div", { className: "groupedBtnRow", children: [_jsx(ButtonComponent, { defaultCSS: "groupBtn", normalCSS: "groupBtnNormal", imgSrc: leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.imgSrc, showToolTip: true, title: leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.ariaLabel, direction: commonDirection, ariaLabel: leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.ariaLabel, ariaHidden: isRightPanel && btnDisable((_l = leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) !== null && _l !== void 0 ? _l : '') ? true : undefined, isWhiteBoard: useWhiteBoardMode, clickHandler: function () {
                                    var isLinear = (leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) === 'horizontalPieces' || (leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) === 'verticalPieces';
                                    if (isLinear) {
                                        createLinearPieceForSelectedTile(leftBtn_2.id);
                                        return;
                                    }
                                    closeAllPopups();
                                    closeManipulatorPopup();
                                    customEventHandler.dispatchEvent('bottomPanel', {
                                        panel: 'bottomPanel',
                                        id: leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id,
                                        type: tool.type,
                                    });
                                }, onMouseDown: function (e) {
                                    if ((leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) === 'horizontalPieces' || (leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) === 'verticalPieces') {
                                        handleLinearPieceMouseDown(e, leftBtn_2.id);
                                    }
                                }, onTouchStart: function (e) {
                                    if ((leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) === 'horizontalPieces' || (leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) === 'verticalPieces') {
                                        handleLinearPieceMouseDown(e, leftBtn_2.id);
                                    }
                                }, type: "imageType1", disabled: btnDisable((_m = leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id) !== null && _m !== void 0 ? _m : '') }, leftBtn_2 === null || leftBtn_2 === void 0 ? void 0 : leftBtn_2.id), _jsx("div", { className: "groupedBtnDivider" }), _jsx(ButtonComponent, { defaultCSS: "groupBtn", normalCSS: "groupBtnNormal", imgSrc: rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.imgSrc, showToolTip: true, direction: commonDirection, title: rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.ariaLabel, ariaLabel: rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.ariaLabel, ariaHidden: isRightPanel && btnDisable((_o = rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) !== null && _o !== void 0 ? _o : '') ? true : undefined, isWhiteBoard: useWhiteBoardMode, clickHandler: function () {
                                    var isLinear = (rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) === 'horizontalPieces' || (rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) === 'verticalPieces';
                                    if (isLinear) {
                                        createLinearPieceForSelectedTile(rightBtn_2.id);
                                        return;
                                    }
                                    closeAllPopups();
                                    closeManipulatorPopup();
                                    customEventHandler.dispatchEvent('bottomPanel', {
                                        panel: 'bottomPanel',
                                        id: rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id,
                                        type: tool.type,
                                    });
                                }, onMouseDown: function (e) {
                                    if ((rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) === 'horizontalPieces' || (rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) === 'verticalPieces') {
                                        handleLinearPieceMouseDown(e, rightBtn_2.id);
                                    }
                                }, onTouchStart: function (e) {
                                    if ((rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) === 'horizontalPieces' || (rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) === 'verticalPieces') {
                                        handleLinearPieceMouseDown(e, rightBtn_2.id);
                                    }
                                }, type: "imageType1", disabled: btnDisable((_p = rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id) !== null && _p !== void 0 ? _p : '') }, rightBtn_2 === null || rightBtn_2 === void 0 ? void 0 : rightBtn_2.id)] })] }, "grouped_".concat(tool.id, "_").concat(index)));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'groupedColoredBtn') {
            var isDisableAll = (_q = tool.elements) === null || _q === void 0 ? void 0 : _q.every(function (el) { var _a; return btnDisable((_a = el.id) !== null && _a !== void 0 ? _a : ''); });
            return (_jsxs("div", { className: "groupedBtnWrapper", "aria-hidden": isRightPanel && isDisableAll ? true : undefined, children: [tool.title && (_jsx("span", { className: "groupedBtnLabel".concat(isDisableAll ? ' disabled' : ''), children: t(tool.title) })), _jsx("div", { className: "groupedBtnGrid grid-2x2", children: (_r = tool.elements) === null || _r === void 0 ? void 0 : _r.map(function (element, elIndex) {
                            var _a, _b;
                            return (_jsxs(React.Fragment, { children: [elIndex > 0 && tool.elements && tool.elements.length <= 2 && (_jsx("div", { className: "groupedBtnDivider" })), _jsx(ButtonComponent, { defaultCSS: "groupBtn", normalCSS: "groupBtnNormal", imgSrc: element.imgSrc, showToolTip: true, title: element.ariaLabel, direction: commonDirection, ariaLabel: element.ariaLabel, ariaHidden: isRightPanel && btnDisable((_a = element.id) !== null && _a !== void 0 ? _a : '') ? true : undefined, isWhiteBoard: useWhiteBoardMode, onMouseDown: function (e) {
                                            if (element.id === 'horizontalPieces' || element.id === 'verticalPieces') {
                                                handleLinearPieceMouseDown(e, element.id);
                                            }
                                        }, onTouchStart: function (e) {
                                            if (element.id === 'horizontalPieces' || element.id === 'verticalPieces') {
                                                handleLinearPieceMouseDown(e, element.id);
                                            }
                                        }, clickHandler: function () {
                                            var isLinear = element.id === 'horizontalPieces' || element.id === 'verticalPieces';
                                            if (isLinear)
                                                return;
                                            closeAllPopups();
                                            closeManipulatorPopup();
                                            customEventHandler.dispatchEvent('bottomPanel', {
                                                panel: 'bottomPanel',
                                                id: element.id,
                                                type: tool.type,
                                            });
                                        }, type: "imageType1", disabled: btnDisable((_b = element.id) !== null && _b !== void 0 ? _b : '') })] }, element.id));
                        }) })] }, "grouped_".concat(tool.id, "_").concat(index)));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'stampBtn') {
            return (_jsx("div", { style: { position: 'relative', display: 'flex', alignItems: 'center' }, children: (drawerOpen === undefined || drawerOpen) && (_jsx(CollapsibleDiv, { elements: tool.elements || [], mainElement: tool.imgSrc, onCollapseClick: function (data) {
                        closeAllPopups();
                        closeManipulatorPopup();
                        customEventHandler.dispatchEvent('bottomPanel', {
                            panel: 'bottomPanel',
                            id: tool.id + '_collapsibleBtn',
                            type: tool.type,
                            data: data,
                        });
                    }, onSelect: function (data) {
                        closeAllPopups();
                        closeManipulatorPopup();
                        customEventHandler.dispatchEvent('bottomPanel', {
                            panel: 'bottomPanel',
                            id: tool.id,
                            type: tool.type,
                            data: data,
                        });
                    }, type: "imageType1", collapsibleContainerCSS: "_btnHolder", mainEleDefaultCSS: "collapsibleMainElement", elemsDefaultCSS: 'collapsibleOptionElem', containerCSS: tool === null || tool === void 0 ? void 0 : tool.collapsibleDrawerCSS, openAt: 'left', direction: "left", 
                    // The panel uses position: fixed (see scoped override in
                    // collapsible.scss for `.open_left.expanded_left.squareBox`)
                    // so we feed it viewport-space coords by setting
                    // isParentRelative=false. CollapsibleDiv's calcOptionHolderCss
                    // then writes (left, top) values that map 1:1 with the viewport.
                    isParentRelative: false, isInnerTooltipRelative: true, title: t((_s = tool.title) !== null && _s !== void 0 ? _s : ''), ariaLabel: tool.ariaLabel, showToolTip: true, zoomLevel: 1, isWhiteBoard: false, controlledCollapse: tool === null || tool === void 0 ? void 0 : tool.controlledCollapse, innerBtnType: (_t = tool === null || tool === void 0 ? void 0 : tool.innerBtnType) !== null && _t !== void 0 ? _t : undefined, collapsibleOpen: (tool === null || tool === void 0 ? void 0 : tool.controlledCollapse)
                        ? ((_v = (_u = collapsibleState.find(function (item) { return item.id === tool.id; })) === null || _u === void 0 ? void 0 : _u.activeCollapsible) !== null && _v !== void 0 ? _v : undefined)
                        : false, activeElements: (_x = (_w = collapsibleState.find(function (item) { return item.id === tool.id; })) === null || _w === void 0 ? void 0 : _w.activeElements) !== null && _x !== void 0 ? _x : undefined, mainActiveOnSelection: tool.id === 'fractionOverlay' })) }));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'choralBtn') {
            var wrapperId = "wrapper_".concat(tool.id);
            return (_jsxs("div", { id: wrapperId, className: "choralBtnWrapper", style: { position: 'relative', display: 'flex', alignItems: 'center', gap: '4px' }, children: [_jsx(ButtonComponent, { imgSrc: tool.imgSrc, defaultCSS: "toolBtn", normalCSS: "toolBtns", ariaLabel: tool.ariaLabel, clickActive: true, title: tool.ariaLabel, showToolTip: true, isActive: showChoralDrawerSt, direction: commonDirection, isParentRelative: commonIsRelative, isWhiteBoard: useWhiteBoardMode, clickHandler: function () {
                            closeManipulatorPopup();
                            var wasOpen = showChoralDrawerSt;
                            closeAllPopups();
                            if (!wasOpen) {
                                setChoralDrawerSt(true);
                            }
                        } }), showChoralDrawerSt && drawerOpen && (_jsx(ChoralControlsDrawer, { onClose: function () { setShowChoralDrawer(false); setChoralDrawerSt(false); } }))] }, tool.id));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'stampEveryBtn') {
            var wrapperId = "wrapper_".concat(tool.id);
            return (_jsxs("div", { id: wrapperId, className: "stampEveryBtnWrapper", style: { position: 'relative', display: 'flex', alignItems: 'center', gap: '4px' }, children: [_jsx(ButtonComponent, { imgSrc: tool.imgSrc, defaultCSS: "toolBtn", normalCSS: "toolBtns", ariaLabel: tool.ariaLabel, title: tool.ariaLabel, showToolTip: true, clickActive: true, isActive: showStampEverySt, direction: commonDirection, isParentRelative: commonIsRelative, isWhiteBoard: useWhiteBoardMode, clickHandler: function () {
                            closeManipulatorPopup();
                            var wasOpen = showStampEverySt;
                            closeAllPopups();
                            if (!wasOpen) {
                                setStampEverySt(true);
                            }
                        } }), showStampEverySt && drawerOpen && (_jsx(StampEveryPopup, { onClose: function () { return setShowStampEveryPopup(false); }, setClose: setStampEverySt }))] }, tool.id));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'exchangeBtn') {
            return (_jsxs("div", { className: "exchangeBtnWrapper ".concat(isRightPanel && tool.title ? "iconBtnWrapper ".concat(tool.id) : ''), style: {
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px',
                }, children: [isRightPanel && tool.title && (_jsx("div", { className: "iconBtnLabel", "aria-hidden": "true", children: t(tool.title) })), _jsxs("div", { style: commonIsRelative ? { position: 'relative' } : {}, children: [_jsx(ButtonComponent, { imgSrc: tool.imgSrc, text: tool.text ? t(tool.text) : '', defaultCSS: "toolBtn", normalCSS: "toolBtn", ariaLabel: t(tool.ariaLabel), title: tool.ariaLabel, showToolTip: true, clickActive: true, isActive: showExchangePopupSt, direction: commonDirection, isParentRelative: commonIsRelative, isWhiteBoard: useWhiteBoardMode, disabled: btnDisable(tool.id), type: "imageType1", clickHandler: function () {
                                    closeManipulatorPopup();
                                    var wasOpen = showExchangePopupSt;
                                    closeAllPopups();
                                    if (!wasOpen) {
                                        setExchangePopupSt(true);
                                    }
                                } }), showExchangePopupSt && drawerOpen && (_jsx(PopoverMenu, { onClose: function () { return setExchangePopupSt(false); }, setClose: setExchangePopupSt, elements: (tool.elements || []) }))] })] }, tool.id));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'fractionBtn' && drawerOpen) {
            var isLastFractionBtn = ((_y = toolsBtn[index + 1]) === null || _y === void 0 ? void 0 : _y.type) !== 'fractionBtn';
            return (_jsx(FractionButton, { tool: tool, index: index, manipulative: manipulative, selectedTool: selectedTool, closeManipulatorPopup: closeManipulatorPopup, customEventHandler: customEventHandler, isLast: isLastFractionBtn }));
        }
        else if ((tool === null || tool === void 0 ? void 0 : tool.type) === 'blocks' && drawerOpen) {
            return _jsx(BlocksComponent, {});
        }
    };
    var handlePointerDown = function (e) {
        e.stopPropagation();
        if (!isRightPanel) {
            e.preventDefault();
        }
    };
    var _u = React.useMemo(function () {
        var fractionTileTools = [];
        var fractionSpecialTools = [];
        var isFractionTile = false;
        for (var _i = 0, toolsBtn_1 = toolsBtn; _i < toolsBtn_1.length; _i++) {
            var tool = toolsBtn_1[_i];
            if (tool.type === 'fractionBtn') {
                isFractionTile = true;
            }
            if (tool.id === 'fraction-tile-glue' || tool.id === 'fraction-tile-scissors') {
                fractionSpecialTools.push(tool);
            }
            else {
                fractionTileTools.push(tool);
            }
        }
        return { isFractionTile: isFractionTile, fractionTileTools: fractionTileTools, fractionSpecialTools: fractionSpecialTools };
    }, [toolsBtn]), isFractionTile = _u.isFractionTile, fractionTileTools = _u.fractionTileTools, fractionSpecialTools = _u.fractionSpecialTools;
    var renderFractionTileItem = function (tool, index) {
        var isSpecial = tool.id === 'fraction-tile-glue' || tool.id === 'fraction-tile-scissors';
        var renderedTool = renderToolItem(tool, index);
        if (isSpecial) {
            return renderedTool;
        }
        return (_jsx("div", { className: "fraction-tile-item", children: renderedTool }, "fraction_tile_".concat(index)));
    };
    var completedGrpArray = [];
    var renderToolItem = function (tool, index) {
        var isElementDisabled = tool.id ? disabledElements.includes(tool.id) : false;
        var showDivider = isFractionTile
            ? tool.id === 'fraction-tile-scissors' || tool.id === 'fraction-tile-glue'
            : index !== 0;
        // If tool has a groupId, group all tools with the same groupId into one wrapper div
        if (tool.groupId) {
            // Already rendered this group — skip
            if (completedGrpArray.includes(tool.groupId)) {
                return null;
            }
            // Mark group as rendered
            completedGrpArray.push(tool.groupId);
            // Collect all tools belonging to this group
            var groupTools = toolsBtn.filter(function (t) { return t.groupId === tool.groupId; });
            return (_jsxs(React.Fragment, { children: [showDivider && _jsx("div", { className: "dividerLine" }), _jsx("div", { className: "btnGroupWrapper ".concat(tool.groupId), children: groupTools.map(function (grpTool, grpIndex) {
                            var isGrpDisabled = grpTool.id ? disabledElements.includes(grpTool.id) : false;
                            return (_jsxs(React.Fragment, { children: [grpIndex !== 0 && _jsx("div", { className: "dividerLine" }), renderComponents(grpTool, grpIndex, isGrpDisabled)] }, "grp_".concat(tool.groupId, "_").concat(grpIndex)));
                        }) })] }, "grp_".concat(tool.groupId)));
        }
        return (_jsxs(React.Fragment, { children: [showDivider && _jsx("div", { className: "dividerLine" }), renderComponents(tool, index, isElementDisabled)] }, "btn_".concat(index)));
    };
    return (_jsxs("div", __assign({ id: id, className: "bottomPanelToolContainer ".concat(className, " ").concat(hasVerticalScroll ? 'has-vertical-scroll' : ''), tabIndex: -1 }, (id === 'rightSideToolPanel'
        ? { role: 'presentation' }
        : { role: 'toolbar', 'aria-label': t('text.textFormatting'), 'aria-orientation': 'horizontal' }), { onPointerDown: handlePointerDown, children: [isFractionTile ? (_jsxs("div", { className: "fractionTileContainer", children: [_jsx(CustomScrollbar, { direction: 'vertical', children: _jsx("div", { className: "fractionGroupContainer ".concat(hasVerticalScroll ? 'has-vertical-scroll' : ''), ref: fractionGroupRef, children: fractionTileTools.map(renderFractionTileItem) }) }), _jsx("div", { className: "fractionSpecialTools", children: fractionSpecialTools.map(renderToolItem) })] })) : (toolsBtn.map(renderToolItem)), children] })));
};
export default BottomPanel;
